/// <summary>
/// This object provides js functions for ... <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 20.9.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 20.9.2022                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.vcMenuTemplate", jQuery.common.VisualBase, {
    vcV: new vcVisual(),
    vcC: new vcCommon(),

           //hi
    //NEXT:
    //TODO:  docu code - until too late
    //TODO: unify design of all popups
    //TODO: extract ramp code to ramp archive
    //TODO: unclean tags with special characters (line break??) hide signal
    //TODO: experimental - store chart temporarily - make more flexible (height, position, ...)
    //TODO: wait for activating export until valid data?
    //TODO: meterreadings - manual meter readings should not show in current meter readings but in meter readings archive



    //TODO: vcDsEdit2 öffnet mit anderem datum als im archiv!?
    //TODO. show/hide data list does not work
    //TODO: add bugs/features from Teams channel: EUDT Entwicklung / Feedback - Archiv 3.0
    //TODO: highcharts xls has <br/> in date - what to do?
    //TODO: rename 'Temperatur' in top menu into 'aussentemparatur' - eventl. tooltip

    //TODO: improve details


    //BUGS:
    //TODO: ignore plaus as chart limit icon is missing
    //TODO: heatmap jpg export not nice
    //TODO: dataflow: only zoom and small reload button, filter buggy
    //TODO: on session out - move to login?
    //TODO: archive rules cannot get url-exported
    //TODO: eventl laded etwas immer öfter, je öfter man den widget startet!!


    //FEATURES:
    //TODO: vcTree and signals - filter by chart type  hide all
    //TODO: highcharts data list as option
    //TODO: data center 3.0
    //TODO: add signal sorting, status
    //TODO: Signallist buggy: plauslist, status, and more in masterSignalList
    //TODO: meta - with prices
    //TODO: add co2 to subsignal, pie chart and data flow
    //TODO: zst for months
    //TODO: temporary charts as registers




    //DATA CENTER
    //TODO: move ramp code to subclass
    //TODO: add senderPoints? in raw data chart  AFU
    //TODO: dsEdit2 - add signal information to data edit popup
    //TODO: temp charts need a reload button 

    _initVariables: function () { objArchSettings._setVariables(this); },

    _addAdditionalChartsToSettings: function () { objArchSettings._addAdditionalChartsToSettings(this); },

    _initHTML: function () {
        var me = this;
        try {
            me.ready = false;

            //everything ok?
            if (!me.specific.bNoError) { me.error = true; me.showMessage(me.resources.err_loadData, true); return false; }
            me.showMessage("", false);

            me._initVariables();

            //init our structure
            me.vcMenu.obj = me.element.find(".vc-menu");

            me._initTriggers();

            me._addAdditionalChartsToSettings();          

            objArchSettings._parseHwOptions(me);

            // we set our user rights
            objArchSettings._setUserRights(me);

            objArchSettings._setInitialDates(me);

            _VCMQ.addConsumer(me.vcgid);

            _VCMQ.consume($(me.visual), me.options.invoke.vcgid, function (e) { me._doEvent(e) });

            //we build our basic html structure
            me._buildStructure();

            //we add a bit of flair to our structure based on our settings
            objArchSettings._setSettings(me);

            //we fill the basic structure with more specific content
            me._fillStructure();          

            objArchSettings._setUserOptions(me);            

            me._initDateBox();

            //we set specific withs
            me._setWidths();

            //we start with the correct view for the first time
            me._toggleView();

            //we fetch the tree menu and the signals and reload the first time
            me.status.dirty.signals = true;
            me.status.dirty.treeMenu = true;
            me._setAdditionalDirty(true);

            me._fetchData();

            if (me.settings.menu.top.charts.enabled) { me._setChartMenuItem(me.fnd("#btn-" + me.settings.defaultChart)); }

            me.status.menu.selectedChart = me.settings.defaultChart; // selectedChart must be set initially for each chart/widget

            me.ready = true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        /// <summary>
        /// Handles different events 
        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }

            // add eventNamespace for document event for correct removal during destroy
            var eventNamespace = ".RampArchive" + this.uuid;

            objChartClickHandler._initChartClickHandlerStuff(me);      

            me._initEditDialog(0.95, 0.95, "vc-menu", function (obj) {

                // if the ticket dialog is closed, we fetch all open tickets again to be sure, that the ticket icon for each signal is visualized correctly (also for added/deleted tickets)
                if (me.myDiv.children("#div-dialogticket").length > 0) { objSignalTickets._fetchOpenTickets(me); }

                if (me.myDiv.hasClass("reload")) {
                    me.status.dirty.signals = true;
                    me.status.dirty.treeMenu = true;
                    me._fetchData();
                }

                //reset html of dialog
                me.editDialog.html("");

            });


            //init the full-text search
            me.vcMenu.selection.entries.menu.filter.find("#div-filter").vcFilter({
                callback: function () {
                    // reload the signal selection area
                    me._filterAndReloadSignalSelection(true);
                }
            });

            //add different toggle events for the menu buttons
            me._toggleTreeMenu();
            if (me.settings.menu.top.interval.enabled) me._toggleInterval();
            if (me.settings.menu.top.datatype.enabled) me._toggleDataType();
            if (me.settings.menu.top.charts.enabled) me._toggleMenuTopCharts();
            if (me.settings.menu.top.opt.enabled) me._initMenuTopOpt();

            if (me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart) {
                $(document).on("click" + eventNamespace, function (e) {
                    if (me.vcMenu.selection.entries.menu.dcFeatures.menu.is(":visible") && $(e.target).closest("#s-dc-features").length === 0) {
                        me.vcMenu.selection.entries.menu.dcFeatures.menu.hide();
                        me._toggleContentOpacity();
                    }
                });

                me.vcMenu.selection.entries.menu.dcFeatures.off("click", "#btn-select-dc-feature").on("click", "#btn-select-dc-feature", function () {
                    me.vcMenu.selection.entries.menu.dcFeatures.menu.toggle();
                    me._toggleContentOpacity();
                });
            }


            //if we use the ddl top menu, we init the ddl opening/closing
            if (me.settings.menu.top.showMenuAsDropdown) {

                // if charts or datatype dropdown menu is visible and click is outside of the dropdown menu, menu is closed and opacity of background is set to default value again
                $(document).on("click" + eventNamespace, function (e) {

                    if (me.vcMenu.menu.top.charts.menu.is(":visible") && $(e.target).closest("#m-charts").length === 0) {
                        me.vcMenu.menu.top.charts.menu.hide();
                        me._toggleContentOpacity();
                    }

                    if (me.vcMenu.menu.top.dataType.menu.is(":visible") && $(e.target).closest("#m-datatype").length === 0) {
                        me.vcMenu.menu.top.dataType.menu.hide();
                        me._toggleContentOpacity();
                    }
                });

                // toggle visibility of dropdown menu for charts selection and opacity of background (by clicking on charts button in top menu)
                me.vcMenu.menu.top.charts.off("click", "#btn-select-charts").on("click", "#btn-select-charts", function () {
                    me.vcMenu.menu.top.charts.menu.toggle();
                    me._toggleContentOpacity();
                });

                // toggle visibility of dropdown menu for datatype selection and opacity of background (by clicking on datatype button in top menu)
                me.vcMenu.menu.top.dataType.off("click", "#btn-select-datatype").on("click", "#btn-select-datatype", function () {
                    me.vcMenu.menu.top.dataType.menu.toggle();
                    me._toggleContentOpacity();
                });
            }


            // if mobile version is active, interval is also shown as dropdown menu
            if (me.settings.mobile) {
                $(document).on("click" + eventNamespace, function (e) {
                    if (me.vcMenu.menu.top.interval.menu.is(":visible") && $(e.target).closest("#m-interval").length === 0) {
                        me.vcMenu.menu.top.interval.menu.hide();
                        me._toggleContentOpacity();
                    }
                });

                // toggle visibility of dropdown menu for interval selection and opacity of background (by clicking on interval button in top menu)
                me.vcMenu.menu.top.interval.off("click", "#btn-select-interval").on("click", "#btn-select-interval", function () {
                    me.vcMenu.menu.top.interval.menu.toggle();
                    me._toggleContentOpacity();
                });

            }

            if (me.settings.menu.top.export.enabled) { objArchExport._initExportEvents(me); }

            if (me.settings.menu.main.rampOptions.enabled) me._toggleRampOptionsChartType();
           

            if (me.settings.menu.main.button.enabled) {
                //we only add the selection button if we want to toggle the selection part and the content
                if (me.settings.toggleView) {
                    me.vcMenu.menu.main.button.find("#btn-select").off("click").on("click", function () {

                        // if icon chart is opened during click on selection button, icon chart is closed and resetted
                        if (me.settings.currentIconChart.active)
                            me._closeIconChart();

                        me.status.showContent = !me.status.showContent;
                        me._toggleView();
                    });
                }

                me.vcMenu.menu.main.button.find("#btn-reload").off("click").on("click", function () {
                    if (me.status.signals.allSelectedBsaids.length > me.status.signals.selectionLimit && me.settings.defaultChart == "archive") {
                        me.openAskDialog(me.specific.resources.tooManySignalsSelected, { at: 'center center-30%', of: window }, function () {
                            if (me.settings.toggleView) me.status.showContent = true;
                            me._reload();
                        }, function () { return true; }); 
                    }
                    else {
                        //if active we show the content
                        if (me.settings.toggleView) me.status.showContent = true;
                        me._reload();
                    }
                });

                if (me.settings.menu.main.button.showTakeBtnOnly) {
                    me.vcMenu.menu.main.button.find("#btn-take").off("click").on("click", function () {
                        me._trigger("PopupSelection", { id: me.options.parameter.PopupIdentifier, list: me.status.signals.selectedBsaids });
                    });
                }
            }

            if (me.settings.menu.main.date.enabled) {
                me.vcMenu.menu.main.date.find(".menu .button-toggle").on("click", function (e) {
                    me.status.date.isSingle = (parseInt(me.vcMenu.menu.main.date.vcOptionBox("getIndex")) == 0); 
                    me._trigger("MenuChanged", true);
                });
            }

            me._toggleDateComparison();
            
            me.vcMenu.menu.top.dataType.find("#btn-15min-consumption").off("click").on("click", function () { objArchSettings._saveUserOptions(me, $(this)); });
            me.vcMenu.menu.top.dataType.find("#btn-fill0").off("click").on("click", function () { objArchSettings._saveUserOptions(me, $(this)); });
            me.vcMenu.menu.top.dataType.find("#btn-add-temp").off("click").on("click", function () { objArchSettings._saveUserOptions(me, $(this)); });
            me.vcMenu.menu.top.dataType.find("#btn-show-plaus").off("click").on("click", function () { objArchSettings._saveUserOptions(me, $(this)); });


            if (me.settings.menu.main.rampResolution.enabled) {
                me.vcMenu.menu.main.rampResolution.find(".ramp-icon").off("click").on("click", function () { objArchSettings._saveUserOptions(me, $(this)); });
                me.vcMenu.menu.main.rampResolution.find("#ramp-option-archive-resolution").off("change").on("change", function () { objArchSettings._saveUserOptions(me, $(this)); });
            }

            if (me.settings.menu.main.rampOptions.enabled) { me.vcMenu.menu.main.rampOptions.find(".ramp-icon").off("click").on("click", function () { objArchSettings._saveUserOptions(me, $(this)); }); }

            //handle choice list events
            if (me.settings.signalSelection) {
                if (me.settings.selection.choice.enabled) {

                    me.vcMenu.selection.wrapper.find("#btn-choice-clear").on("click", function (e) { me._clearChoiceList(); }).button();
                    me.vcMenu.selection.wrapper.find("#btn-choice-add-all").on("click", function (e) { me._selectAll("lst-signal", true); }).button();
                    me.vcMenu.selection.wrapper.find("#btn-choice-remove-all").on("click", function (e) { me._selectAll("lst-signal", false); }).button();
                    me.vcMenu.selection.wrapper.find("#s-choice").off("click", ".choice-clear-single").on("click", ".choice-clear-single", function () { me._removeItemFromChoiceList($(this)); });
                    me._toggleChoiceListMenu();
                }

                // add dc filter button events
                if (me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart) { objDataCenter._toggleDcFilters(me); }         

                me.visual.find("#s-signals").off("click", "#lst-signal li").on("click", "#lst-signal li", function () { me._selectEntry($(this)); });

            }


            //hover/click events for the edit icon of the tag list and the signal icons
            me.vcMenu.selection.entries.signals.on("mouseenter", ".col2", function () { $(this).append("<div data-type='TAGS' class='edit-icon'><i class='fa fa-pencil icon-color-info' ></i></div>"); });
            me.vcMenu.selection.entries.signals.on("mouseleave", ".col2", function () { $(this).children("div.edit-icon").remove(); });
            me.vcMenu.selection.entries.signals.off("click", ".edit-icon").on("click", ".edit-icon", function (e) { me.status.signalDetails.Object = $(this); me._loadIconContent(me.status); e.stopPropagation(); });
            me.visual.find("#s-signals").off("click", "#lst-signal li .popup").on("click", "#lst-signal li .popup", function (e) {
                me.status.signalDetails.Object = $(this);
                if(!$(this).hasClass("ticket-inactive")) // TODO MKU: check if disabled state is okay
                    me._loadIconContent(me.status);
                e.stopPropagation();
            });


            eventNamespace = "." + this.container.id;

            $(document).on('getStatusOfCurrArchive' + eventNamespace, function (event, data) {

                // if the event is triggered by the desired archive, selected date is sent back, otherwise not
                if (data.widgetId === me.vcMenu.obj.attr('id')) {
                    var date = me.status.date.singleDate;
                    if (!me.status.date.isSingle)
                        date = me.status.date.dateRange;                    

                    const clonedStatus = me._deepCloneWithoutCircularRefs(me);

                    me.vcMenu.obj.trigger('sendStatusOfCurrArchive', { date: date, interval: me.status.menu.interval, isSingle: me.status.date.isSingle, archiveId: data.archiveId, status: clonedStatus });
                    
                }
            });

            $(document).on('openNewArchiveWithDefaultStatus' + eventNamespace, function (event, data) {

                // if the event is triggered by the desired archive, selected date is sent back, otherwise not
                if (data.param === me.vcMenu.obj.attr('id')) {                    
                    me._loadStatusFromOtherArchive(data.status, true);
                }
            });

            $(document).on('loadStatusOfArchive' + eventNamespace, function (event, data) {

                // if the event is triggered by the desired archive, selected date is sent back, otherwise not
                if (data.param === me.vcMenu.obj.attr('id')) {                   
                    me._loadStatusFromOtherArchive(data.status, false); 
                }
            });


            me.vcMenu.menu.top.dcProject.find("#btn-dc-heatmap").off("click").on("click", function () {
                me.editDialog.dialog("option", { "width": me.editDialog.width*0.8, "height": me.editDialog.height*0.9 });
                var filters = (me.status && me.status.dcFilters && me.status.dcFilters.filterLists) ? (me.status.dcFilters.filterLists.activeValFilters || []) : [];

                var param = {
                    LoggerId: me.specific.LoggerId,
                    Bsaids: me.status.signals.allSelectedBsaids,
                    ActiveValFilters: filters,
                    ErrorType: objDataCenter._getStartErrorTypeFromArchive(me)
                };

                $("#div-dialog").ProjectOverview({ invokeType: "addVisualBase", parameter: param });
                me.editDialog.dialog("open");



            });

            


            // ---------------------- init everything that needs to be init/loaded again for any reason -----------------------------

            //init events for subvisuals
            me._initSubvisualEvents();

            //set user options for data types again, otherwise not correctly loaded
            objArchSettings._setDataTypeUserOptions(me);      

            //set widths of main menu correctly e.g. for the mobile version
            me._setMainMenuWidths();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },   

    _deepCloneWithoutCircularRefs: function (obj, seen = new WeakMap()) {
        var me = this;
        try {
        if (obj && typeof obj === 'object') {
            
            if (seen.has(obj)) {
                return seen.get(obj); 
            }

            const copy = Array.isArray(obj) ? [] : {};
            seen.set(obj, copy);

            // copy all keys of object
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    copy[key] = me._deepCloneWithoutCircularRefs(obj[key], seen);
                }
            }

            return copy;
        }

            return obj;

        } catch (e) { me._writeErr(e); return false; }
    },

    _filterAndReloadSignalSelection: function (reloadDirty) {
        /// <summary>
        /// This function triggers the filtering and reload of the signal selection area
        /// </summary>
        var me = this;
        try {
            if (me.status && me.status.isArchiveLoading) return true;
            me._trigger("ReloadDirty", reloadDirty);
            me._filter();
        } catch (e) { me._writeErr(e); return false; }
    },

    _initTriggers: function () {
        /// <summary>
        /// Handles different VCMQ messages
        /// </summary>
        var me = this;
        try {

            // add eventNamespace for body event for correct removal during destroy
            var eventNamespace = ".RampArchive" + this.uuid;

            $("body").on("Trigger-vcMenu-ReloadDirty" + eventNamespace, function (e) {
                if (e.vcgid == me.vcgid) {
                    me.status.dirty.reload = e.values;
                    if (!me.status.signalDetails.show) {
                        me._loadContentWithoutReloadButton();
                        me._toggleReloadButtonState();
                    } else {
                        me._loadIconContent(me.status);
                    }
                }
            });

            $("body").on("Trigger-vcMenu-MenuChanged" + eventNamespace, function (e) {
                if (e.vcgid == me.vcgid) {
                    me._setNewStatus();

                    if (me.settings.menu.top.showMenuAsDropdown && me.settings.menu.top.datatype.enabled) {
                        if (me.vcMenu.menu.top.dataType.menu.is(":visible")) {
                            me.vcMenu.menu.top.dataType.menu.hide();
                            me._toggleContentOpacity();
                        }
                    }
                }
            });
            

            // update date box - _setNewStatus is triggered there
            $("body").on("Trigger-vcMenu-IntervalChanged" + eventNamespace, function (e) {  
                if (e.vcgid == me.vcgid) {
                    me._updateDateBox(false);

                    if (me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart) {
                        objDataCenter._updateVisibilityOfDcArea(me);                                               
                    }
                }
            });


        } catch (ex) { me._writeErr(ex); }
    },

    _trigger: function (name, value) {
        /// <summary>
        /// sends one single trigger
        /// </summary>
        var me = this;
        try {
            $("body").trigger({ type: "Trigger-vcMenu-" + name, vcgid: me.vcgid, value: value });
        } catch (ex) { me._writeErr(ex); }
    },

    _doEvent: function (event) {
        /// <summary>
        /// Handles different VCMQ messages
        /// </summary>
        var me = this;

        try {
            if (event !== null) {
                // if (event.msg !== "LOG") console.info(event.msg + " --- " + jQuery.now());
                //_VCMQ.produce(this.visual, this.vcgid, 'LOG', "on event: " + event.msg);
                switch (event.msg) {

                    case 'MYSTATE':
                        // console.info("MQ-MYSTATE-" + me.status.menu.selectedChart + ": " + me.vcMenu.obj.attr("id"));
                        break;


                    case 'RAMP_CLICK':
                        if (me.settings.userRights.showChartClick ) {
                            //open the chart click handler after we clicked into one chart point
                            if (me.status.menu.activateDataCenter || me.specific.DataCenterStart) {
                                objChartClickHandler._openChartClickHandler(me, event);
                            }
                        }
                        break;

                    case 'DSEDIT_CLOSE':

                        // plaus info is fetched again                        
                        me.status.dirty.plausList = true;
                        objSignalPlaus._showPlausInfo(me);

                        if (me.settings.userRights.showChartClick) {  

                            // event.values contains the vcgid of the archive, where the dsEditDialog has been opened
                            // check if event vcgid is the same as the current vcgid - only if it is the current archive, reload shall be executed!
                            if (event.values === me.vcgid) {
                                //if active we show the content
                                if (me.settings.toggleView) me.status.showContent = true;
                                //me._reload();                              
                                
                            }                         
                        }
                        break;

                    case 'MODAL_CLOSE':
                        if (me.settings.userRights.showChartClick) {
                            // if multiplaus popup is closed, plaus info is fetched again
                            if (me.chartClick.type === "multiplaus") {
                                me.status.dirty.plausList = true;
                                objSignalPlaus._showPlausInfo(me);
                            }

                            // reset chartclick type for next popup
                            me.chartClick.type = null;

                        }
                        break;

                    case 'VCMENU_RELOAD_DIRTY':
                        console.info("mq - reload dirty");

                        break;

                    case 'SIGNAL_ANALOG_DETAIL_CLOSE':
                        me.status.dirty.signals = true;
                        break;

                    case 'VCMENU_MENU_CHANGED': //triggered by editDialop popups on close
                        console.info("mq - menu changed");
                        //alert("VCMENU MENU CHANGED depracated");
                        // me._setNewStatus();
                        break;
                    case 'CHART_SETTINGS': //triggered by archiveFavorites on load
                        me._getRampForFavorites();
                        break;



                    case 'CHART_SERIES_HIDE':
                        if (me.status.signals.hiddenSeries.indexOf(parseInt(event.values)) < 0) { me.status.signals.hiddenSeries.push(parseInt(event.values)); }
                        break;
                    case 'CHART_SERIES_SHOW':
                        var index = me.status.signals.hiddenSeries.indexOf(parseInt(event.values));
                        if (index > -1) { me.status.signals.hiddenSeries.splice(index, 1); }
                        break;
                    case 'CHART_SERIES_CLEAR':
                        _VCMQ.produce(me.visual, me.vcgid, 'CHART_DIRTY', '');
                        me.status.signals.hiddenSeries = [];
                        break;
                    //case 'VCMENU_CLOSE_DIALOG':
                    //    me.editDialog.dialog("close");
                    //    me.myDiv.html("");
                    //    break;


                    case 'DC_PROJECT_OVERVIEW_SELECT_DAY': // from project overview heatmap
                        try {
                            if (!event.values || !event.values.date) { break; }

                            var date = event.values.date;

                            // set everything to interval 1 and correct date
                            me.status.date.interval = 1;
                            me.status.date.isSingle = true;
                            me.status.date.singleDate = date;
                            me.status.date.dateRange = { from: date, to: date };
                            me.status.menu.interval = 1;

                            // set date box to single date
                            me.vcMenu.menu.main.date.vcOptionBox("setIndex", 0);

                            me._setSelectedDates();
                            me._updateDateBox(true);

                            
                            if (!me.status.dcFilters) { me.status.dcFilters = {}; }
                            me.status.dcFilters.selectedHeatmapErrorType = event.values.errorType || null;

                            // we load the content again
                            if (me.settings.toggleView) {
                                me.status.showContent = true;
                            }

                            me._reload();

                        } catch (ex) {
                            me._writeErr(ex);
                        }
                        break;



                    case "DC_PROJECT_OVERVIEW_SELECT_RANGE": // from project overview heatmap
                        try {
                            if (!event.values || !event.values.from || !event.values.to) { break; }

                            var from = event.values.from;
                            var to = event.values.to;

                            // set interval + range
                            me.status.date.interval = 1;
                            me.status.date.isSingle = false;
                            me.status.date.singleDate = null;
                            me.status.date.dateRange = { from: from, to: to };
                            me.status.menu.interval = 1;

                            // set date box to range
                            me.vcMenu.menu.main.date.vcOptionBox("setIndex", 1);

                            me._setSelectedDates();
                            me._updateDateBox(true);

                            if (!me.status.dcFilters) { me.status.dcFilters = {}; }
                            me.status.dcFilters.selectedHeatmapErrorType = event.values.errorType || null;

                            if (me.settings.toggleView) {
                                me.status.showContent = true;
                            }

                            me._reload();
                        } catch (ex) {
                            me._writeErr(ex);
                        }
                        break;







                    default: break;
                }


            }
        } catch (ex) { me._writeErr(ex); }
    },




    _loadStatusFromOtherArchive: function (newStatus, newArchive) {
        var me = this;

        function updateStatusObject(target, source) {
            for (var key in source) {
                if (source.hasOwnProperty(key)) {
                    // we check if object is nested, otherwise value can be set directly
                    if (typeof source[key] === 'object' && source[key] !== null && !Array.isArray(source[key])) {
                        if (!target[key]) target[key] = {};
                        // recursive call for nested object 
                        updateStatusObject(target[key], source[key]);
                    } else {
                        // value can be set directly
                        target[key] = source[key];
                    }
                }
            }
        }

        try {   


            me._showArchiveLoading();

            // during the change of archives, data is not loaded and signals and tree menu are dirty, so we set the according status values
            me.status.dataLoaded = false;
            me.status.dirty.signals = true;
            me.status.dirty.treeMenu = true;


            objChartTempHistory._cleanExperimentalTempCharts(me);

            updateStatusObject(me, newStatus);


            me.getData({ typeid: 8 }, function (result) {
                me.specific.userOptions = result.userOptions;
                me.specific.userOptionsSL = result.userOptionsSL;
                objArchSettings._setUserOptions(me);
                objArchSettings._setDataTypeUserOptions(me);
            });


            //if (newArchive) {

            //    // get userOptions again (could be changed in another archive) to always have the values saved in the database
            //    me.getData({ typeid: 8 }, function (result) {
            //        me.specific.userOptions = result.userOptions;
            //        me.specific.userOptionsSL = result.userOptionsSL;
            //        me.specific.userRights = result.userRights;
            //        objArchSettings._updateUserRightsForOpenArchive(me);
            //        objArchSettings._setUserOptions(me);
            //        objArchSettings._setDataTypeUserOptions(me);

            //        //// we need to update some top menu visibilities
            //        //me._updateFillStructure();
            //    });
            //}
            //else { // load userOptions and userRights for opened/desired archive
            //    me.specific.userOptions = newStatus.specific.userOptions;
            //    me.specific.userOptionsSL = newStatus.specific.userOptionsSL;
            //    me.specific.userRights = newStatus.specific.userRights;
            //    objArchSettings._updateUserRightsForOpenArchive(me);
            //    objArchSettings._setUserOptions(me);
            //    objArchSettings._setDataTypeUserOptions(me);

            //    //// we need to update some top menu visibilities
            //    //me._updateFillStructure();
            //}
          
            // we need a timeout, otherwise timing issue and the following functions are probably called before status object update is finished
            // all following functions are then called, as soon as call back is empty again
            setTimeout(function () {
                me._toggleView();
                me._setTreeMenuButtons();
                objChartTempHistory._loadExperimentalTempCharts(me);

                me._resetMenuFromStatus();

                // set correct date in date box and correct interval
                //me._updateDateBox(true);
                //me._setIntervalButton(me.status.date.interval);

                //we fetch the tree menu and the signals and reload the first time
                me.status.dirty.signals = true;
                me.status.dirty.treeMenu = true;
                me._setAdditionalDirty(true);

                // set menu buttons according to status and reload everything
                me._setNewStatus();
                me._reload();                    
            }, 0);

        } catch (ex) { me._writeErr(ex); }
    },
       

    _initDateBox: function () {
        /// <summary>
        /// This function initiates the whole date box stuff
        /// </summary>
        var me = this;
        try {
            if (me.settings.menu.main.date.enabled) {

                me.vcMenu.menu.main.calSingle = $("<div>");

                me.vcMenu.menu.main.calRange = $("<div>");
                me.vcMenu.menu.main.calRange.vcDate({
                    mode: "Range", align: "right", interval: 1, langID: me.settings.userLangIDForCulture, callback: function (obj) {
                        me.status.date.dateRange = obj.dateRange;
                        if (me.ready) {
                            me._trigger("MenuChanged", true);
                        }
                    }
                })
                var optionBoxItems = [
                    {
                        button: me.specific.resources.date, clickable: true, content: me.vcMenu.menu.main.calSingle, funct: function () {
                            me.vcMenu.menu.main.calSingle.vcDate({
                                mode: "Single", align: "center", interval: me.status.date.interval, defaultDate: me.status.date.singleDate, langID: me.settings.userLangIDForCulture, callback: function (obj) {
                                    me.status.date.singleDate = obj.singleDate;
                                    if (me.ready) { me._trigger("MenuChanged", true);}
                                }
                            })
                        }
                    }
                ]; 
                 
                if (me.settings.menu.main.date.showTimespan) { optionBoxItems.push({ button: me.specific.resources.period, clickable: true, content: me.vcMenu.menu.main.calRange }) };
                me.vcMenu.menu.main.date.vcOptionBox({ caption: me.specific.resources.period, items: optionBoxItems, callback: function () { }
                });

            }

        } catch (e) { me._writeErr(e); }
    },

    _initIconChart: function (type) {
        /// <summary>
        /// Function to initiates the loading of an icon chart
        /// </summary>
        var me = this;
        try {
            me.status.signalDetails.show = true;
            me.vcMenu.selection.entries.menu.wrapper.hide();
            me.vcMenu.selection.entries.signals.hide();
            me.vcMenu.selection.entries.signalDetails.show();

            //-----currently actually only needed for zstinfo
            // set selected icon chart active
            me.settings.currentIconChart.active = true;
            me.settings.currentIconChart.iconChart = me.settings.iconCharts.filter(function (item) { return item.id == type })[0];

            var inactive = true;
            // check if iconChart.exports are defined for the current icon chart
            if (me.settings.currentIconChart.iconChart.exports.length > 0)
                inactive = false;

            // if export methods are set for current icon chart, export btn is enabled 
            me.vcMenu.menu.top.exportBtn.find("#btn-export-menu").toggleClass("inactive", inactive);

        } catch (e) { me._writeErr(e); return false; }
    },

    

    // TODO MKU: check for better solution!!!
    _setSessionStorage: function () {
        /// <summary>
        /// Function to set a session storage to store all signal information; session storage can be accessed in other classes
        /// </summary>
        var me = this;
        try {

            // get all selected signals (all signal info) based on selected bsaids
            var lst = [];
            $.each(me.status.signals.allSelectedBsaids, function () {
                let bsaid = this;
                let signal = me.signals.filter(function (item) { return item.id == bsaid })[0];
                lst.push(signal);
            });

            var data = JSON.stringify(lst);

            sessionStorage.removeItem('allSignals');
            sessionStorage.setItem('allSignals', data);

        } catch (e) { me._writeErr(e); return false; }
    },

    _loadIconContent: function (contentStatus) {
        /// <summary>
        /// Handles different icon events
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            var obj = me.status.signalDetails.Object;

            var type = obj.data("type");
            var bsaid = obj.parents("li.vc-list-item").data("id");
            var isRule = obj.parents("li").hasClass("isRule");

            var day = me.status.menu.endDate;

            var div = me.vcMenu.selection.entries.signalDetails.find("#s-signal-details-content");

            cont = { random: me.options.invoke.vcgid + 2, prefix: "my-details-" }
            cont.obj = $("<div>").attr("id", cont.prefix + cont.random);
            cont.obj.height(div.height());
            cont.obj.width(me.vcMenu.selection.entries.wrapper.width());
            div.html(cont.obj);

            me.editDialog.html(me.vcC.getLoadingIcon());

            switch (type) {

                case "SANKEY":
                    me._initIconChart(type);
                    var param = { interval: contentStatus.menu.interval, datatype: 2, startDate: contentStatus.menu.startDate, endDate: contentStatus.menu.endDate, usePrices: contentStatus.menu.usePrice, useCo2: contentStatus.menu.useCo2, dateUserDef: true, HideLegend: true };
                    var signalParam = JSON.stringify({ "signalID": bsaid, "archiveParam": param });
                    me.vcV.addVisualBaseByName(cont.prefix, "VISUAL_SIGNAL_SANKEY", cont.random, getCurrentTimestamp(), cont.obj.height(), cont.obj.width(), "", signalParam, me.settings.deviceType);
                    break;

                case "SUBSIGNAL":
                    me._initIconChart(type);
                    var param = JSON.stringify({ loggerid: me.specific.LoggerId, interval: contentStatus.menu.interval, datatype: 2, startDate: contentStatus.menu.startDate, endDate: contentStatus.menu.endDate, usePrices: contentStatus.menu.usePrice, dateUserDef: true, isArchive: true });
                    var signalParam = JSON.stringify({ "signalID": bsaid });
                    me.vcV.addVisualBaseByName(cont.prefix, "VC_CHART_SUBSIGNALS", cont.random, getCurrentTimestamp(), cont.obj.height(), cont.obj.width() - 10, param, signalParam, me.settings.deviceType);
                    break;
                case "ALARM":
                    me._initIconChart(type);
                    me.vcV.addVisualBaseByName(cont.prefix, "VISUAL_SIGNALANALOG_ALARMSUMMARY", cont.random, getCurrentTimestamp(), cont.obj.height(), cont.obj.width(), "", JSON.stringify({ 'bsaid': bsaid }), me.settings.deviceType);
                    break;
                case "SIGNALINFO":                   
                    me.vcV.showSignalAnalogSummaryDialog(bsaid);
                    break;
                case "DATACENTER":
                    me.vcV.showDsEdit2Dialog({ LoggerId: me.specific.LoggerId, bsaid: bsaid, day: day });
                    break;
                case "ZSTINFO":
                    me._initIconChart(type);
                    var param = { bsaid: bsaid, startDate: contentStatus.menu.startDate, endDate: contentStatus.menu.endDate, DataType: -1, LoggerId: me.specific.LoggerId };
                    me.settings.currentIconChart.parameter = param;
                    cont.obj.ArchiveMeterReadings({ invokeType: "addVisualBase", parameter: me.settings.currentIconChart.parameter, deviceType: me.settings.deviceType });
                    break;
                case "TICKET":
                    var param = { "ReadOnlyMode": true, 'SignalID': bsaid, LoggerID: me.specific.LoggerId };
                    me.editDialog.dialog("option", { "width": me.editDialog.width, "height": me.editDialog.height });
                    me.myDiv.removeClass("reload");
                    $("#div-dialog").TicketList({ invokeType: "addVisualBase", parameter: param });
                    me.editDialog.dialog("open");
                    break;
                case "TAGS":
                    if (isRule) { bsaid = bsaid * -1; }
                    me.editDialog.dialog("option", { "width": 988, "height": me.editDialog.height });
                    me.myDiv.removeClass("reload").addClass("reload").html($("<div>").attr("id", "div-dialogtags").width(975).height(me.editDialog.height - 100));
                    me.vcV.addVisualContentByName('div-dia', "VISUAL_TAGS_ASSIGNMENT_TAGS2SIGNAL", "logtags", getCurrentTimestamp(), me.editDialog.height - 100, 975, JSON.stringify({ "assid": bsaid }), "", me.settings.deviceType);
                    me.editDialog.dialog("open");
                    break;
                default:

            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _loadContent: function (contentStatus, isMainChart, tmpPrefix, tmpId, tmpWidth, tmpHeight) {
        var me = this;
        try {
            if (!me.error) {

                me.status.firstChoiceFilled = true;

                if (me.settings.selection.entries.signals.showIcons) {
                    me.status.signalDetails.show = false;
                    me.vcMenu.selection.entries.signals.show();
                    me.vcMenu.selection.entries.menu.wrapper.show();
                    me.vcMenu.selection.entries.signalDetails.hide();
                }

                isMainChart = isMainChart == null ? true : isMainChart;

                if (isMainChart) {

                    me.vcMenu.selection.entries.signals.find(".vc-list-item .col3").show();

                    //we set specific heights  - yes - it's a hack, but otherwise we get the wrong height when we start the first chart - I don't know why 
                    me._setHeights();

                    //show charts which need no selected signals 
                    switch (contentStatus.menu.selectedChart) {

                        case "plauslist":
                            contentStatus.showContent = false;
                            me._toggleView();
                            me.vcMenu.selection.entries.signals.find(".vc-list-item .col3").hide();
                            if (!contentStatus.dirty.plausList) return true;
                            objSignalListItems._fetchPlausList(me);
                            break;

                            return true;
                        case "docu":

                            contentStatus.showContent = false;
                            me._toggleView();
                            //me.vcMenu.selection.entries.signals.find(".vc-list-item .col3").hide();
                            if (!contentStatus.dirty.details) return true;
                            objSignalDetails._showDetails(me);
                            break;
                        case "status":
                            contentStatus.showContent = false;
                            me._toggleView();
                            me.vcMenu.selection.entries.signals.find(".vc-list-item .col3").hide();
                            if (!contentStatus.dirty.status) return true;
                            objSignalListItems._fetchStatus(me);
                            break;
                    }
                }

                if (contentStatus.signals.selectedBsaids.length == 0) { me.vcMenu.content.html($("<div>").addClass("note").html(me.resources.noEntriesExist)); return true; }

                var cont;
                if (isMainChart) {
                    cont = { random: me.options.invoke.vcgid + 1, prefix: "my-content-" }
                    cont.obj = $("<div>").attr("id", cont.prefix + cont.random);
                    cont.obj.height(me.vcMenu.content.height());
                    cont.obj.width(me.vcMenu.content.width());
                    me.vcMenu.content.html(cont.obj);

                } else {
                    cont = { random: tmpId, prefix: tmpPrefix }
                    cont.obj = $("<div>").attr("id", cont.prefix + cont.random);
                    cont.obj.height(tmpHeight);
                    cont.obj.width(tmpWidth);
                }

                cont.obj.html(me.vcC.getLoadingIcon());

                //sets the current name for the global visual list 
                me.globalVisualListKey = contentStatus.menu.selectedChart;

                switch (contentStatus.menu.selectedChart) {
                    case "archive": case "min": case "max": case "load": case "rawdata": case "zst":

                        //sets the current name for the global visual list 
                        me.globalVisualListKey = "ramp" + (me.options.invoke.vcgid + 1);

                        var n = me._getRampVisualName(contentStatus);
                        var p = JSON.stringify(me._getRampParameter(contentStatus));
                        var sp = JSON.stringify(me._getRampSignalParameter(contentStatus));

                        var shareParam = JSON.parse(p);
                        shareParam.isArchive = false;
                        shareParam.UseSimpleBottomLegend = true;
                        shareParam.ShowExportIcons = false;
                        shareParam.ShowIntervention = false;
                        shareParam.HideSeries = false;

                        contentStatus.signals.shareParameter = {
                            'info': { bsaid: -1, name: '', description: '', startDate: shareParam.startDate, endDate: shareParam.endDate, dateUserDef: shareParam.dateUserDef, interval: shareParam.interval },
                            'visualname': n, 'parameter': JSON.stringify(shareParam), 'signalparameter': sp
                        };

                        me.vcV.addRampBaseByName(cont.prefix, n, cont.random, getCurrentTimestamp(), parseInt(cont.obj.height()), parseInt(cont.obj.width()), p, sp, me.settings.deviceType);

                        break;


                    default:         
                        me._loadSubvisualContent(contentStatus); // load subvisual content for all others 
                }

                if (me.settings.menu.main.history.enabled) objChartTempHistory._handleHistory(me);

            }

        } catch (e) { me._writeErr(e); }
    },

    _setToggleStatusOptionBox: function () {
        /// <summary>
        /// This function sets the toggle status of the option box<br/>
        /// Is used from outside of vcMenuTemplate for toggle the visibility of the option box
        /// If selection is shown, option box shall be invisible. If content is shown, option box shall be visible.
        /// </summary>
        var me = this;
        try {
            me.status.toggleOptionBoxVisibility = true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _getRampVisualName: function (contentStatus) {
        /// <summary>
        /// This function returns the visual name based on the selected time interval.<br/>
        /// </summary>
        var me = this;
        try {
            var sVisualName = "-";

            switch (contentStatus.menu.selectedChart) {
                case "archive": case "min": case "max": case "load": case "zst":
                    switch (contentStatus.menu.interval) {
                        case 1:
                            sVisualName = 'VISUAL_RAMP_SINGLE';
                            break;
                        case 3:
                            sVisualName = 'VISUAL_RAMP_DAILY';
                            break;
                        case 5:
                            sVisualName = 'VISUAL_RAMP_MONTHLY';
                            break;

                    }
                    break;
                case "rawdata":
                    sVisualName = "VISUAL_RAMP_HR";
                    break;

                default:
            }

            return sVisualName;


        } catch (e) { me._writeErr(e); }
    },

    _getRampParameter: function (contentStatus) {
        /// <summary>
        /// Based on the current menu and 
        /// </summary>
        var me = this;

        try {

            var param = {
                loggerID: me.specific.LoggerId,
                interval: contentStatus.menu.interval,
                startDate: contentStatus.menu.startDate,
                endDate: contentStatus.menu.endDate,
                dateUserDef: !contentStatus.date.isSingle,
                ShowExportIcons: false,
                datatype: contentStatus.menu.datatype,
                showLogo: true,
                isArchive: true,

                ShowZstForSingleValues: false,
                isCumulated: contentStatus.menu.accumulated,
                GetSingleValuesAsConsumption: contentStatus.menu.singleValueAsConsumption,
                usePrices: (contentStatus.menu.usePrice || contentStatus.menu.useCo2),
                useCo2AsPrice: contentStatus.menu.useCo2,
                FillNullValues: contentStatus.menu.fill0,

                ShowInvalidValues: true, // me.settings.menu.top.datatype.showDataCenter,
                ShowDataCenterMode: me.settings.menu.top.datatype.showDataCenter,

                HideSeries: true,
                ListHiddenSeries: contentStatus.signals.hiddenSeries,

                MqEventOnPointClick: me.settings.menu.top.datatype.showDataCenter,
               'MqEventName': "RAMP_CLICK",
            };

            if (me.settings.menu.main.rampOptions.enabled) {
                param.fixTooltip = me.vcMenu.menu.main.rampOptions.find("#ramp-option-fix-tooltip").hasClass("button-toggle-active");
                param.ShowPlotLines = me.vcMenu.menu.main.rampOptions.find("#ramp-option-add-plotline").hasClass("button-toggle-active");
                param.NoZoom = me.vcMenu.menu.main.rampOptions.find("#ramp-option-no-zoom").hasClass("button-toggle-active");
                param.ShowIntervention = me.vcMenu.menu.main.rampOptions.find("#ramp-option-show-interventions").hasClass("button-toggle-active");
                param.separateMetAxis = me.vcMenu.menu.main.rampOptions.find("#ramp-option-sep-temp").hasClass("button-toggle-active");
                param.separateDataAxis = me.vcMenu.menu.main.rampOptions.find("#ramp-option-sep-axis").hasClass("button-toggle-active");
            } else {
                param.fixTooltip = false;
                param.ShowPlotLines = true;
                param.NoZoom = false;
                param.ShowIntervention = false;
                param.separateMetAxis = false;
                param.separateDataAxis = false;
            }
            if (me.settings.menu.main.rampResolution.enabled) {
                param.ArchiveResolutionSingleValues = parseInt(me.vcMenu.menu.main.rampResolution.find("#ramp-option-archive-resolution").val());
                param.ShowUnsmoothedValues = me.vcMenu.menu.main.rampResolution.find("#ramp-option-unsmoothed").hasClass("button-toggle-active");
                param.StartingHour = parseInt(me.vcMenu.menu.main.rampResolution.find("#ramp-option-start-hour").val());
            } else {
                param.ArchiveResolutionSingleValues = 1;
                param.ShowUnsmoothedValues = false;
                param.StartingHour = 0;
            }

            switch (contentStatus.menu.selectedChart) {
                case "load":
                    param.SortDataDescending = true;
                    break;
                case "rawdata":
                    param.interval = 10;
                    param.HighResolutionAsRawData = false;
                    break;

                case "zst":
                    param.ShowZstForDailyValues = true;
                    break;
                default:

                    break;
            }

            //calculate the interval difference for automatic differences later on (eg. favorites or share-url)
            param.AutoDateUserDefInterval = 0;
            if (!contentStatus.date.isSingle) {
                let dif = moment(contentStatus.menu.endDate, 'DD.MM.YYYY').diff(moment(contentStatus.menu.startDate, 'DD.MM.YYYY'), 'days');
                if (dif !== 0) param.AutoDateUserDefInterval = parseInt(dif)  * -1;
            }
        
            //set the different comparison dates,
            param.AutoComparisonInterval = 0;
            switch (contentStatus.date.dateComparisonType) {
                case 0: //flexible interval
                    var val = parseInt(me.vcMenu.menu.main.specificIntervalCompare.val());
                    if (isNaN(val)) { alert(me.specific.resources.noFlexInterval); return null; }
                    param.AutoComparisonInterval = parseInt(me.vcMenu.menu.main.specificIntervalCompare.val()); break;
                case 1: //fix interval
                    param.compareStartDate = contentStatus.date.dateRangeComparison.from;
                    param.compareEndDate = contentStatus.date.dateRangeComparison.to;
                    break;

                case 2: //last year comparison
                    param.AutoPreviousPeriodComparison = true; break;
            }

            return param;

        } catch (e) { me._writeErr(e); return null; }
    },

    _getRampSignalParameter: function (contentStatus) {
        /// <summary>
        /// 
        /// </summary>
        var me = this;

        var signalParam = { 'series': [] };
        try {

            var mySelectedBsaids = contentStatus.signals.selectedBsaids.slice();
            var mySelectedMeta = contentStatus.signals.selectedMeta.slice();
            //add the optional temperature signal if option is active
            if (contentStatus.menu.addTemp && contentStatus.signals.temperatureBsaid > -1) {
                if (mySelectedBsaids.indexOf(contentStatus.signals.temperatureBsaid) == -1) mySelectedBsaids.push(contentStatus.signals.temperatureBsaid);
            }

            $.each(mySelectedBsaids, function () {

                let bsaid = parseInt(this);
                let signal = me.signals.filter(function (item) { return item.id == bsaid })[0];

                if (!signal.isarchiverule) {

                    if (mySelectedMeta.length == 0) {
                        //basic signal selection
                        var series = { ruleType: 1, mtid: [], seriesType: contentStatus.menu.chartType };
                        series.bsaid = [parseInt(this)];
                        series.rule = "[bsaid=" + parseInt(this) + "]";
                        signalParam.series.push(series);
                    } else {
                        //merge all signals with meta types
                        $.each(mySelectedMeta, function () {
                            var meta = parseInt(this);
                            var series = { ruleType: 3, seriesType: contentStatus.menu.chartType };
                            series.ruleType = 3;
                            series.mtid = [];
                            series.bsaid = [bsaid, meta];
                            series.rule = "[bsaid=" + bsaid + "] / [bsaid=" + meta + "]";
                            signalParam.series.push(series);
                        });

                    }
                } else {
                    //we got an archive rule
                    //NOTE: we cannot mix meta types and archive rules
                    var series = { ruleType: 3, mtid: [], seriesType: contentStatus.menu.chartType };
                    series.rid = bsaid;
                    series.bsaid = signal.rule_bsaid.replace("{", "").replace("}", "").split(",");
                    series.rule = signal.rule;
                    signalParam.series.push(series);
                }

            });


            return signalParam;
        } catch (e) { me._writeErr(e); return null; }
    },

    _getRampForFavorites: function () {
        /// <summary> This function sends the current ramp chart settings to the favorite lists. </summary>
        var me = this;
        try {

            var p = me._getRampParameter(me.status);
            if (p == null) return false;
            p.isArchive = false;
            _VCMQ.produce(me.visual, me.vcgid, 'CHART_SEND_SETTINGS', { 'visualname': me._getRampVisualName(me.status), 'param': p, 'signalparam': me._getRampSignalParameter(me.status) });
        } catch (e) { me._writeErr(e); return false; }
    },

    _toggleContentOpacity: function () {
        /// <summary>
        /// This function toggles the opacity of the content/background, if a dropdown menu of the top menu or in the datacenter area is opened.
        /// </summary>
        var me = this;
        try {

            var obj = me.vcMenu.menu.top;
            if (obj.dataType.menu.is(":visible") || obj.charts.menu.is(":visible")
                || (me.settings.mobile && obj.interval.menu.is(":visible"))) {
                me.fnd("#m-main").css("opacity", "0.2");
                me.fnd("#my-content").css("opacity", "0.2");
                me.fnd("#s-wrapper").css("opacity", "0.2");
                return true;
            }

            if (me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart) {
                if (me.vcMenu.selection.entries.menu.dcFeatures.menu.is(":visible")) {
                    me.fnd("#m-wrapper").css("opacity", "0.2");
                    me.fnd("#s-choice").css("opacity", "0.2");
                    me.fnd("#s-treemenu").css("opacity", "0.2");
                    me.fnd("#s-signals").css("opacity", "0.2");
                    return true;
                }
            }

            // default opacity settings
            me.fnd("#m-main").css("opacity", "1.0");
            me.fnd("#my-content").css("opacity", "1.0");
            me.fnd("#s-wrapper").css("opacity", "1.0");

            me.fnd("#m-wrapper").css("opacity", "1.0");
            me.fnd("#s-choice").css("opacity", "1.0");
            me.fnd("#s-treemenu").css("opacity", "1.0");
            me.fnd("#s-signals").css("opacity", "1.0");

        } catch (e) { me._writeErr(e); return false; }
    },

    _fillTopMenuOverviewlist: function () {
        /// <summary>
        /// This function fills the list of selected charts in the top menu.
        /// Each selected chart is directly added to the list
        /// </summary>
        var me = this;
        try {
            

            let list = me.vcMenu.menu.top.overview.list;

            // set margins for selection buttons in top menu
            me.vcMenu.menu.top.overview.wrapper.find("#m-datatype").removeClass("vc-grid-margin-right").css("margin-right", "1px");

            if (!me.settings.mobile) { // if mobile version or not, width of interval area is different
                const w = me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart ? "212px" : "298px";
                me.vcMenu.menu.top.overview.wrapper.find("#m-interval").css({ "width": w });
            }
            else
                me.vcMenu.menu.top.overview.wrapper.find("#m-interval").removeClass("vc-grid-margin-right").css({ "margin-right": "9px", "margin-left": "1px" });

            me.vcMenu.menu.top.overview.wrapper.find("#m-charts").removeClass("vc-grid-margin-right").css("margin-right", "9px");

            list.html("");

            // add wrapper for selected charts
            var hChart = ButtonMenu._setMenuHeader("m-list-header", me.specific.resources.options).css("background", "white"); // $("<div>").attr("id", "m-list-header").addClass("vc-list-header-simple").html(me.specific.resources.options).css("background", "white");
            var currChart = $("<div>").attr("id", "m-top-overview-selection").addClass("flex-gap").css("text-align", "center");

            // add options to selection list if selected
            if (me.status.menu.accumulated) currChart.append($("<div>").addClass("button-toggle inactive").html("<i class='fa fa-arrow-up-right-dots'></i><br/>" + me.specific.resources.accumulated));
            if (me.status.menu.singleValueAsConsumption) currChart.append($("<div>").addClass("button-toggle not-allowed-interval-3 not-allowed-interval-5 inactive").html("<i class='fa fa-sigma'></i><br/>" + me.specific.resources.consumption));
            if (me.status.menu.fill0) currChart.append($("<div>").addClass("button-toggle inactive").html("<i class='fa fa-terminal'></i><br/>" + me.specific.resources.fillLeaks));
            if (me.status.menu.usePrice) currChart.append($("<div>").addClass("button-toggle inactive").html("<i class='fa fa-coins'></i><br/>" + me.specific.resources.price));
            if (me.status.menu.useCo2) currChart.append($("<div>").addClass("button-toggle inactive").html("<i class='fa-brands fa-envira'></i><br/>" + me.specific.resources.co2));

            if (me.status.menu.addTemp) currChart.append($("<div>").addClass("button-toggle inactive").html("<i class='fa fa-thermometer-full'></i><br/>" + me.specific.resources.temperature));
            if (me.status.menu.showDetails) currChart.append($("<div>").addClass("button-toggle inactive").html("<i class='fa fa-memo-circle-info'></i><br/>" + me.specific.resources.docu));
            
            list.append(hChart, currChart);

            // calculate header width of datatype selection list
            me._setHeightsWidthsOfTopMenu(me.vcMenu.menu.top.overview.list);            

            list.find(".button-toggle").button();

        } catch (e) { me._writeErr(e); }
    },

    _setHeightsWidthsOfTopMenu: function (list) {
        /// <summary>
        /// calculates and sets the height of some parts of the top menu again
        /// </summary>
        var me = this;
        try {
            let btn = list.find(".button-toggle");

            var wrapperWidth = me.vcMenu.menu.wrapper.find("#m-datatype").outerWidth();
            var wList = me.vcMenu.menu.wrapper.find("#m-top-overview-selection").outerWidth();

            if (btn.length > 0) {
                var newWidth = wrapperWidth + wList - 0.5; // calculate width of overlaying header (if buttons are added to the list, the header of the selection button needs to be extended)
                var header = me.vcMenu.menu.wrapper.find("#m-datatype .vc-list-header-simple").css({ "width": newWidth, "box-sizing": "border-box" });
                header.addClass("overlay");
                me.vcMenu.menu.wrapper.find("#btn-select-datatype").css("margin-top", header.outerHeight()); // little hack is necessary - move selection btn down, otherwise header is overlaying
            }
            else {
                var btnSelect = me.vcMenu.menu.wrapper.find("#btn-select-datatype");
                btnSelect.css("margin-top", "0px");
                me.vcMenu.menu.wrapper.find("#m-datatype .vc-list-header-simple").css({ "width": "92.33px", "box-sizing": "border-box" }).removeClass("overlay"); // move selection btn to default position again
            }
        } catch (e) { me._writeErr(e); }
    },


    _setDataType: function () {
        var me = this;
        try {

            /// <item>1 = single 15min value</item>
            /// <item>2 = sum</item>
            /// <item>3 = min</item>
            /// <item>4 = max</item>
            /// <item>5 = avg</item>
            /// <item>6 = zst</item>
            switch (me.status.menu.selectedChart) {
                case "min": me.status.menu.datatype = 3; break;  //min value
                case "max": me.status.menu.datatype = 4; break;  //max value

                default:
                    me.status.menu.datatype = me.status.menu.interval == 1 ? 1 : 2;
                    break;
            }

        } catch (e) { me._writeErr(e); }
    },


    _specificRampSettings: function () {
        /// <summary>
        /// we have to show/hide some specific ramp resolution options 
        /// </summary>
        var me = this;
        try {

            if (me.settings.menu.main.rampResolution.enabled) {
                let obj = me.vcMenu.menu.main.rampResolution;
                if (me.status.menu.interval == 1) {
                    obj.find(".res-single").show();
                    obj.find(".res-rest").hide();
                } else {
                    obj.find(".res-single").hide();
                    obj.find(".res-rest").show();
                }
            }

            if (me.settings.menu.main.dateComparison.enabled) {
                me.vcMenu.menu.main.dateComparison.removeClass("inactive")
                if (me.status.menu.selectedChart == "rawdata") me.vcMenu.menu.main.dateComparison.addClass("inactive");
            }
            if (me.settings.menu.main.rampResolution.enabled) {
                me.vcMenu.menu.main.rampResolution.removeClass("inactive")
                if (me.status.menu.selectedChart == "rawdata") me.vcMenu.menu.main.rampResolution.addClass("inactive");
            }

        } catch (e) { me._writeErr(e); }

    },

    _setAdditionalDirty: function (isDirty) {
        /// <summary>
        /// 
        /// </summary>
        var me = this;
        try {

            me.status.dirty.plausList = isDirty;
            me.status.dirty.status = isDirty;
            me.status.dirty.details = isDirty;            

        } catch (e) { me._writeErr(e); }

    },

    //end region



    //#region "menu settings"

    _setNewStatus: function () {
        /// <summary>
        /// This function sets the whole menu selection to the new status
        /// </summary>
        var me = this;
        try {

            let objToggle = me.vcMenu.menu.top.wrapper;
            if (me.settings.menu.top.showMenuAsDropdown) // if ddl top menu is active, different wrapper is active
                objToggle = me.vcMenu.menu.top.overview.wrapper;

            objToggle.find(".button-toggle").not(".interval, .not-allowed-interval-" + me.status.menu.interval).removeClass("inactive");
            objToggle.find(".button-toggle.set-inactive, .button-toggle.not-allowed-interval-" + me.status.menu.interval).addClass("inactive");

            me.status.menu.accumulated = (objToggle.find("#btn-accumulated").hasClass("button-toggle-active") && !objToggle.find("#btn-accumulated").hasClass("inactive"));
            me.status.menu.fill0 = (objToggle.find("#btn-fill0").hasClass("button-toggle-active") && !objToggle.find("#btn-fill0").hasClass("inactive"));
            me.status.menu.singleValueAsConsumption = (objToggle.find("#btn-15min-consumption").hasClass("button-toggle-active") && !objToggle.find("#btn-15min-consumption").hasClass("inactive"));
            me.status.menu.addTemp = (objToggle.find("#btn-add-temp").hasClass("button-toggle-active") && !objToggle.find("#btn-add-temp").hasClass("inactive"));
            me.status.menu.usePrice = (objToggle.find("#btn-price").hasClass("button-toggle-active") && !objToggle.find("#btn-price").hasClass("inactive"));
            me.status.menu.useCo2 = (objToggle.find("#btn-co2").hasClass("button-toggle-active") && !objToggle.find("#btn-co2").hasClass("inactive"));
            me.status.menu.showDetails = (objToggle.find("#btn-show-details").hasClass("button-toggle-active") && !objToggle.find("#btn-show-details").hasClass("inactive"));

            // set activateDataCenter correctly   
            if (me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart) {
                me.status.menu.activateDataCenter = me.vcMenu.selection.entries.menu.dcBtn.find("#btn-activate-dc").hasClass("button-toggle-active") && !me.vcMenu.selection.entries.menu.dcBtn.find("#btn-activate-dc").hasClass("inactive");
            }

            me._setSelectedDates();
            me._specificRampSettings();
            
            if (me.status.menu.interval === 1) {
                objSignalPlaus._showPlausInfo(me);
            }
            else {
                objSignalPlaus._hidePlausInfo(me);
            }

            me._setDataType();

            //fill the top menu overview list with the current selected charts
            if (me.settings.menu.top.showMenuAsDropdown)
                me._fillTopMenuOverviewlist();

            if (!me.status.signalDetails.show) {
                me._filter();
            }

            me._trigger("ReloadDirty", true);

        } catch (e) { me._writeErr(e); }

    },
   

    _updateDateBox: function (bForceUpdate) {
        var me = this;
        try {


            if (me.settings.menu.main.date.enabled) {


                if (me.status.date.interval !== me.status.menu.interval || bForceUpdate) {
                    me.vcMenu.menu.main.calSingle.vcDate("destroy");

                    me.status.date.interval = me.status.menu.interval;
                    me.vcMenu.menu.main.calSingle.vcDate({
                        mode: "Single", align: "center", interval: me.status.date.interval, defaultDate: me.status.date.singleDate, langID: me.settings.userLangIDForCulture,
                        callback: function (obj) {
                            me.status.date.singleDate = obj.singleDate;
                            me._trigger("MenuChanged", true);
                        }
                    });

                }

                if (bForceUpdate) {

                    me.vcMenu.menu.main.calRange.vcDate("destroy");
                    me.vcMenu.menu.main.calRange.vcDate({
                        mode: "Range", align: "right", interval: 1, langID: me.settings.userLangIDForCulture, defaultRange: me.status.date.dateRange, callback: function (obj) {
                            me.status.date.dateRange = obj.dateRange;
                            me._trigger("MenuChanged", true);
                        }
                    })

                }

            }
        } catch (e) { me._writeErr(e); }
    },

    _setSelectedDates: function () {
        var me = this;
        try {

            // console.info(me.status.date);
            if (me.status.date.singleDate == null) return;

            if (me.status.date.singleDate.length == null) me.status.date.singleDate = moment(me.status.date.singleDate, 'DD.MM.YYYY').format('DD.MM.YYYY');
            if (me.status.date.singleDate.length == 7) me.status.date.singleDate = "01." + me.status.date.singleDate;

            if (me.status.date.isSingle) {
                switch (me.status.menu.interval) {
                    case 1: //single day
                        me.status.menu.startDate = me.status.date.singleDate;
                        me.status.menu.endDate = me.status.date.singleDate;
                        if (me.settings.menu.main.dateComparison.enabled) me.vcMenu.menu.main.specificIntervalCompareCaption.html(me.specific.resources.days);
                        break;

                    case 3: //month
                        me.status.menu.startDate = moment(me.status.date.singleDate, 'DD.MM.YYYY').startOf('month').format('DD.MM.YYYY');
                        me.status.menu.endDate = moment(me.status.date.singleDate, 'DD.MM.YYYY').endOf('month').format('DD.MM.YYYY');

                        if (me.settings.menu.main.dateComparison.enabled) me.vcMenu.menu.main.specificIntervalCompareCaption.html(me.specific.resources.months);
                        break;

                    case 5: //year
                        me.status.menu.startDate = moment(me.status.date.singleDate, 'DD.MM.YYYY').startOf('year').format('DD.MM.YYYY');
                        me.status.menu.endDate = moment(me.status.date.singleDate, 'DD.MM.YYYY').endOf('year').format('DD.MM.YYYY');
                        if (me.settings.menu.main.dateComparison.enabled) me.vcMenu.menu.main.specificIntervalCompareCaption.html(me.specific.resources.years);
                        break;
                    default:
                        break;
                }

            } else {
                me.status.menu.startDate = me.status.date.dateRange.from;
                me.status.menu.endDate = me.status.date.dateRange.to;

                if (me.settings.menu.main.dateComparison.enabled) me.vcMenu.menu.main.specificIntervalCompareCaption.html(me.specific.resources.periods);

            }

        } catch (e) { me._writeErr(e); }
    },

    _toggleSingleMenuItem: function (obj) {
        /// <summary>
        /// toggles the style and updates the state by event
        /// returns the current state 
        /// </summary>
        var me = this;
        try {

            obj.off("click").on("click", function () {
                $(this).toggleClass("button-toggle-active");
                me._trigger("MenuChanged", true);
            }); //.button();
            return $(this).hasClass("button-toggle-active");


        } catch (e) { me._writeErr(e); return false; }

    },

    _setChartMenuItem: function (obj) {
        /// <summary>
        /// this function sets the selected charts in the top menu
        /// settings for the chart are checked and all not allowed buttons are deactivated
        /// </summary>
        var me = this;
        try {

            //if we - optionally - show signal details - now is the time to reset everything
            me.status.signalDetails.show = false;
            me.vcMenu.selection.entries.signals.show();
            me.vcMenu.selection.entries.menu.wrapper.show();
            me.vcMenu.selection.entries.signalDetails.hide();

            //first, we remove button-active for all charts except the current one
            me.vcMenu.menu.top.charts.find(".button-toggle.chart-type").not("#" + obj.attr("id")).removeClass("button-toggle-active");
            //then we toggle state
            obj.removeClass("button-toggle-active").addClass("button-toggle-active");
            //now we remove inactive from all intervals
            me.vcMenu.menu.wrapper.find(".interval").removeClass("inactive");

            //get the settings for this chart
            var chartSettings = me.settings.charts.filter(function (item) { return ("btn-" + item.id) == obj.attr("id") })[0];

            me.status.menu.selectedChart = chartSettings.id;

            // set charts menu button labelling to current selected chart
            if (me.status.menu.selectedChart != "" && me.settings.menu.top.showMenuAsDropdown) {
                me.vcMenu.menu.top.charts.find("#btn-select-charts").html(obj.html() + "<div class='color-bg-secondary separation-line'></div>" + "<i class='ddl-select-btn fa fa-light fa-angles-down'></i>");
                me.vcMenu.menu.top.charts.find("#btn-select-charts > span").css("margin-right", "20px");
                me.vcMenu.menu.top.charts.find(".separation-line").css("margin-left", "77px");
            }
            
            //set correct wrapper for ddl and full top menu version
            let objOpt = me.vcMenu.menu.top.wrapper;
            if (me.settings.menu.top.showMenuAsDropdown) { objOpt = me.vcMenu.menu.top.overview.wrapper; }

            let objInterval = me.vcMenu.menu.wrapper;
            if (me.settings.mobile) { objInterval = me.vcMenu.menu.top.overview.wrapper; }

            //deactivate all not allowed intervals
            $.each(chartSettings.notAllowedInterval, function (index, value) { objInterval.find(".interval-" + value).removeClass("inactive").addClass("inactive"); });


            //active/inactivate specific icons
            objOpt.find("#btn-price").toggleClass("set-inactive", (chartSettings.price == null ? false : chartSettings.price) == false);
            objOpt.find("#btn-co2").toggleClass("set-inactive", (chartSettings.co2 == null ? false : chartSettings.co2) == false);
            objOpt.find("#btn-accumulated").toggleClass("set-inactive", (chartSettings.accumulate == null ? false : chartSettings.accumulate) == false);
            objOpt.find("#btn-fill0").toggleClass("set-inactive", (chartSettings.fill0 == null ? false : chartSettings.fill0) == false);
            objOpt.find("#btn-15min-consumption").toggleClass("set-inactive", (chartSettings.singleValueAsConsumption == null ? false : chartSettings.singleValueAsConsumption) == false);
            objOpt.find("#btn-add-temp, #btn-rules, #btn-intervention, #btn-ticket").toggleClass("set-inactive", (chartSettings.addRampFeatures == null ? false : chartSettings.addRampFeatures) == false);
            objOpt.find("#btn-show-plaus").toggleClass("set-inactive", (chartSettings.plausInfo == null ? false : chartSettings.plausInfo) == false);


            // initially fillSignalList and filter are not necessary, because they are called again 
            if (me.ready) {
                me._fillSignalList(true);
                me._filter();
                me._setAdditionalDirty(true);
            }          

            me._trigger("MenuChanged", true);

        } catch (e) { me._writeErr(e); return false; }

    },

    _toggleInterval: function () {
        /// <summary>
        /// toggles the interval buttons for interval selection
        /// </summary>
        var me = this;
        try {

            // if mobile version, interval buttons are part of interval.menu div
            let obj = me.vcMenu.menu.top.interval;
            if (me.settings.mobile) { obj = me.vcMenu.menu.top.interval.menu; }

            //add toggle events to the interval buttons
            obj.find(".button-toggle").off("click").on("click", function () {
                me._setIntervalButton(parseInt($(this).data("type")));
                me._trigger("IntervalChanged", true);

                if (me.settings.mobile) // hide submenu, if opened, after selecting a different interval
                {
                    obj.hide();
                    me._toggleContentOpacity();
                }

            });

        } catch (e) { me._writeErr(e); }

    },

    _setIntervalButton: function (interval) {
        /// <summary>
        /// sets the selected interval button to active state
        /// </summary>
        var me = this;
        try {
            // if ddl top menu is active, different wrapper is active
            let obj = me.vcMenu.menu.top.interval;
            if (me.settings.mobile) { obj = me.vcMenu.menu.top.interval.menu; }

            let btns = obj.find(".button-toggle");
            btns.removeClass("button-toggle-active");

            var selectedBtn = btns.filter(function () { return $(this).data("type") == interval });
            selectedBtn.addClass("button-toggle-active");

            if (me.settings.mobile) // change label of interval selection btn to new selected interval
            {
                me.vcMenu.menu.top.interval.find("#btn-select-interval").html(selectedBtn.html() + "<div class='color-bg-secondary separation-line'></div>" + "<i class='ddl-select-btn fa fa-light fa-angles-down'></i>" + "<i class='ddl-select-btn fa fa-light fa-angles-down'></i>");
                me.vcMenu.menu.top.interval.find("#btn-select-interval > span").css("margin-right", "20px");
            }

            me.status.menu.interval = interval;

        } catch (e) { me._writeErr(e); }

    },

    _toggleDataType: function () {
        var me = this;
        try {

            var obj = me.vcMenu.menu.top.dataType;
            //add toggle events to all icons

            me.status.menu.accumulated = me._toggleSingleMenuItem(obj.find("#btn-accumulated"), false);
            me.status.menu.singleValueAsConsumption = me._toggleSingleMenuItem(obj.find("#btn-15min-consumption"), false);
            me.status.menu.fill0 = me._toggleSingleMenuItem(obj.find("#btn-fill0"), false);
            me.status.menu.addTemp = me._toggleSingleMenuItem(obj.find("#btn-add-temp"), false);

            //price and co2 are not allowed together
            obj.find("#btn-price").off("click").on("click", function () {
                $(this).toggleClass("button-toggle-active");
                obj.find("#btn-co2").removeClass("button-toggle-active");

                me._trigger("MenuChanged", true);
            });
            obj.find("#btn-co2").off("click").on("click", function () {
                $(this).toggleClass("button-toggle-active");
                obj.find("#btn-price").removeClass("button-toggle-active");

                me._trigger("MenuChanged", true);
            });

            me.status.menu.showDetails = me._toggleSingleMenuItem(obj.find("#btn-show-details"), false);

            obj.find("#btn-show-details").on("click", function () {
                if ($(this).hasClass("button-toggle-active")) {
                    objSignalDetails._showDetails(me);
                } else {
                    objSignalDetails._hideDetails(me);
                }

            });


        } catch (e) { me._writeErr(e); }

    },

    _toggleMenuTopCharts: function () {
        var me = this;
        try {

            // if ddl top menu is active, different wrapper is active
            var obj = me.vcMenu.menu.top.charts;
            if (me.settings.menu.top.showMenuAsDropdown) { obj = me.vcMenu.menu.top.overview.charts; }
            $.each(me.settings.charts, function () {
                if (this.enabled) obj.find("#btn-" + this.id).off("click").on("click", function () {
                    me._setChartMenuItem($(this));
                    if (obj == me.vcMenu.menu.top.overview.charts) {
                        me.vcMenu.menu.top.charts.menu.hide();
                        me._toggleContentOpacity();
                    }
                });
            });

        } catch (e) { me.writeError(e); }

    },

    _initMenuTopOpt: function () {
        var me = this;
        try {

            // if ddl top menu is active, different wrapper is active
            let obj = me.vcMenu.menu.top.wrapper;
            if (me.settings.menu.top.showMenuAsDropdown) { obj = me.vcMenu.menu.top.overview.wrapper; }


            if (me.settings.menu.top.opt.showRules) {
                obj.off("click", "#btn-rules").on("click", "#btn-rules", function () {
                    me.editDialog.dialog("option", { "width": me.editDialog.width, "height": me.editDialog.height });
                    me.myDiv.removeClass("reload").addClass("reload").html($("<div>").attr("id", "div-dialogrules").width(me.editDialog.width - 25).height(me.editDialog.height - 100));
                    me.vcV.addVisualBaseByName("div-dia", "VISUAL_RAMP_SIGNALLIST_ALLRULES", "logrules", getCurrentTimestamp(), me.editDialog.height - 100, me.editDialog.width - 25, JSON.stringify({ 'LoggerId': me.specific.LoggerId }), "", me.settings.deviceType);

                    me.editDialog.dialog("open");
                });
            }
            if (me.settings.menu.top.opt.showTags) {
                obj.find("#btn-tags").off("click").on("click", function () {
                    me.editDialog.dialog("option", { "width": me.editDialog.width, "height": me.editDialog.height });
                    me.myDiv.removeClass("reload").addClass("reload").vcTagManager({ 'ShowCalculations': true, h: me.editDialog.height - 100, w: me.editDialog.width - 25, LoggerId: me.specific.LoggerId });
                    me.editDialog.dialog("open");
                });
            }
            if (me.settings.menu.top.opt.showInterventions) {
                obj.find("#btn-intervention").off("click").on("click", function () {
                    me.editDialog.dialog("option", { "width": me.editDialog.width, "height": me.editDialog.height });
                    me.myDiv.removeClass("reload").html($("<div>").attr("id", "div-dialogintervention").width(me.editDialog.width - 25).height(me.editDialog.height - 100));
                    me.vcV.addVisualBaseByName('div-dia', 'VISUAL_FORM_INTERVENTION', 'logintervention', me.status.menu.startDate, me.editDialog.height - 100, me.editDialog.width - 25, 'true,-1,' + me.specific.LoggerId, "", me.settings.deviceType);
                    me.editDialog.dialog("open");
                });
            }
            if (me.settings.menu.top.opt.showTickets) {
                obj.find("#btn-ticket").off("click").on("click", function () {
                    me.editDialog.dialog("option", { "width": me.editDialog.width, "height": me.editDialog.height });
                    me.myDiv.removeClass("reload").html($("<div>").attr("id", "div-dialogticket").width(me.editDialog.width - 25).height(me.editDialog.height - 100));

                    // get selected bsaids for pre-selecting these signals in the ticket widget
                    var startEntry = { Blid: me.specific.LoggerId, Assignments: { Assignments: [] } };
                    me.status.signals.allSelectedBsaids.forEach(function (bsaid) {
                        startEntry.Assignments.Assignments.push({ AssId: bsaid,  TypeId: 2
                        });
                    });



                    $("#div-dialogticket").TicketList({ invokeType: "addVisualBase", parameter: { LoggerID: me.specific.LoggerId, ReadOnlyMode: !me.settings.userRights.isAdmin, CurrentProjectOnly: true, startEntry: startEntry } });
                   
                    me.editDialog.dialog("open");
                });
            }


        } catch (e) { me._writeErr(e); }
    },


    _toggleRampOptionsChartType: function () {
        var me = this;
        try {

            //add toggle events to the ramp option chart buttons
            let btns = me.vcMenu.menu.main.rampOptions.find(".chart-type");
            btns.off("click").on("click", function () {
                me._setChartTypeButton($(this).data("type"));
                //btns.removeClass("button-toggle-active");
                //$(this).addClass("button-toggle-active");
                //me.status.menu.chartType = $(this).data("type");

                me._trigger("MenuChanged", true);

            }).button();

        } catch (e) { me._writeErr(e); }

    },

    _setChartTypeButton: function (chartType) {
        var me = this;
        try {

            let btns = me.vcMenu.menu.main.rampOptions.find(".chart-type");
            btns.removeClass("button-toggle-active");
            btns.filter(function () { return $(this).data("type") == chartType }).addClass("button-toggle-active");
            me.status.menu.chartType = chartType;

        } catch (e) { me._writeErr(e); }

    },

    _toggleDateComparison: function () {
        /// <summary>
        /// This function overwrites the default menu events for an option box and handles the specific date comparison  <br/>
        /// </summary>
        var me = this;
        try {

            if (me.settings.menu.main.dateComparison.enabled) {

                var obj = me.vcMenu.menu.main.dateComparison;
                //we add a container for "nothing selected"
                var noComp = $("<div>").attr("id", "div-no-date-comparison").html(me.specific.resources.noComparison);
                obj.append(noComp);

                //first, we deactivate everything
                obj.find(".menu .button-toggle-active").toggleClass("button-toggle-active");
                me.status.date.dateComparisonType = -1;

                obj.find(".menu .button-toggle").on("click", function () {
                    var index = parseInt(obj.vcOptionBox("getIndex"));
                    var bShow = false;
                    //if nothing selected - we select the type
                    if (me.status.date.dateComparisonType == -1) {
                        me.status.date.dateComparisonType = index;
                        bShow = true;

                    } else {
                        //if the same was selected - we unselect
                        if (me.status.date.dateComparisonType == index) {
                            $(this).removeClass("button-toggle-active");
                            me.status.date.dateComparisonType = -1;
                            bShow = false;

                        } else {
                            me.status.date.dateComparisonType = index;
                            bShow = true;
                        }
                    }
                    if (bShow) {
                        obj.find(".content").show(); noComp.hide();
                    } else {
                        obj.find(".content").hide(); noComp.show();
                    }

                    me._trigger("MenuChanged", true);
                });


                me.vcMenu.menu.main.specificIntervalCompare.on("change", function () {
                    me.status.date.flexibleInterval = me.vcMenu.menu.main.specificIntervalCompare.val();
                });


            }


        } catch (e) { me._writeErr(e); }
    },



    _resetMenuFromStatus: function () {
        var me = this;
        try {

            //reset the interval
            me._setIntervalButton(me.status.menu.interval);
            let obj = me.vcMenu.menu.top.wrapper;
            obj.find(".button-toggle").not(".interval, .not-allowed-interval-" + me.status.menu.interval).removeClass("inactive");
            obj.find(".button-toggle.set-inactive, .button-toggle.not-allowed-interval-" + me.status.menu.interval).addClass("inactive");


            obj.find("#btn-accumulated").toggleClass("button-toggle-active", me.status.menu.accumulated);
            obj.find("#btn-15min-consumption").toggleClass("button-toggle-active", me.status.menu.singleValueAsConsumption);
            obj.find("#btn-fill0").toggleClass("button-toggle-active", me.status.menu.fill0);
            obj.find("#btn-add-temp").toggleClass("button-toggle-active", me.status.menu.addTemp);
            obj.find("#btn-price").toggleClass("button-toggle-active", me.status.menu.usePrice);
            obj.find("#btn-co2").toggleClass("button-toggle-active", me.status.menu.useCo2);
            obj.find("#btn-show-details").toggleClass("button-toggle-active", me.status.menu.showDetails);

            if (me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart) {
                var activate = me.specific.DataCenterStart || me.status.menu.activateDataCenter;
                me.vcMenu.selection.entries.menu.dcBtn.find("#btn-activate-dc").toggleClass("button-toggle-active", activate);
                objDataCenter._updateVisibilityOfDcArea(me);

                // set status of general faulty button
                var btnFaulty = me.vcMenu.selection.entries.menu.dcFilterBox.find("#btn-filter-faulty");
                btnFaulty.removeClass("button-toggle-active");

                if (me.status.dcFilters.filterLists.activeValFilters.length === 3)
                    btnFaulty.addClass("button-toggle-active");

                // set status of other validity filters
                var valButtons = me.vcMenu.selection.entries.menu.dcFilterBox.find(".invalid-signal");
                me._updateButtonStatus(valButtons, me.status.dcFilters.filterLists.activeValFilters);
                objDataCenter._updateDcFilterBoxText(me, me.status.dcFilters.filterLists.activeValFilters);
                
                var typeButtons = me.vcMenu.selection.entries.menu.filter.find(".signal-type");
                me._updateButtonStatus(typeButtons, me.status.dcFilters.filterLists.activeTypeFilters);
                objDataCenter._updateDcFilterBoxText(me, me.status.dcFilters.filterLists.activeTypeFilters);

                var plausButtons = me.vcMenu.selection.entries.menu.dcFilterBox.find(".plaus-type");
                me._updateButtonStatus(plausButtons, me.status.dcFilters.filterLists.activePlausFilters);
                objDataCenter._updateDcFilterBoxText(me, me.status.dcFilters.filterLists.activePlausFilters);

                var otherButtons = me.vcMenu.selection.entries.menu.dcFilterBox.find(".add-type");
                me._updateButtonStatus(otherButtons, me.status.dcFilters.filterLists.activeAddFilters);
                objDataCenter._updateDcFilterBoxText(me, me.status.dcFilters.filterLists.activeAddFilters);

                var acButtons = me.vcMenu.selection.entries.menu.dcFilterBox.find(".ac-type");
                me._updateButtonStatus(acButtons, me.status.dcFilters.filterLists.activeAutoCheckFilters);
                objDataCenter._updateDcFilterBoxText(me, me.status.dcFilters.filterLists.activeAutoCheckFilters);

                // toggle and set buttons in filter option box correctly 
                var buttons = me.vcMenu.selection.entries.menu.dcFilterBox.find('.menu .button-toggle');
                var valButton = buttons.eq(0).removeClass("button-toggle-active");
                var plausButton = buttons.eq(1).removeClass("button-toggle-active"); 
                var addButton = buttons.eq(2).removeClass("button-toggle-active"); 
                var acButton = buttons.eq(3).removeClass("button-toggle-active");

                var valContentItem = me.vcMenu.selection.entries.menu.dcFilterBox.find('#div-filter-val').closest('.content-item');
                var plausContentItem = me.vcMenu.selection.entries.menu.dcFilterBox.find('#div-filter-plaus').closest('.content-item');
                var addContentItem = me.vcMenu.selection.entries.menu.dcFilterBox.find('#div-filter-add').closest('.content-item'); 
                var acContentItem = me.vcMenu.selection.entries.menu.dcFilterBox.find('#div-filter-ac').closest('.content-item');                  

                let obj = me.status.dcFilters.filterLists;
                if (obj.activePlausFilters.length > 0 && (obj.activeValFilters.length == 0 && obj.activeTypeFilters.length == 0)) {
                    plausButton.addClass("button-toggle-active");
                    valContentItem.removeClass("hide").addClass("hide");
                    plausContentItem.removeClass("hide");                    
                    addContentItem.removeClass("hide").addClass("hide");                    
                    acContentItem.removeClass("hide").addClass("hide");
                }
                else if (obj.activeAddFilters.length > 0 && obj.activePlausFilters.length == 0 && (obj.activeValFilters.length == 0 && obj.activeTypeFilters.length == 0)) {
                    addButton.addClass("button-toggle-active");                    
                    valContentItem.removeClass("hide").addClass("hide");
                    plausContentItem.removeClass("hide").addClass("hide");
                    addContentItem.removeClass("hide");
                    acContentItem.removeClass("hide").addClass("hide");
                }
                else if (obj.activeAutoCheckFilters.length > 0 && obj.activePlausFilters.length == 0 && obj.activeAddFilters.length == 0 && (obj.activeValFilters.length == 0 && obj.activeTypeFilters.length == 0)) {
                    acButton.addClass("button-toggle-active");
                    valContentItem.removeClass("hide").addClass("hide");                    
                    plausContentItem.removeClass("hide").addClass("hide");
                    addContentItem.removeClass("hide").addClass("hide");
                    acContentItem.removeClass("hide");
                }
                else {
                    valButton.addClass("button-toggle-active");
                    valContentItem.removeClass("hide");
                    plausContentItem.removeClass("hide").addClass("hide");
                    addContentItem.removeClass("hide").addClass("hide");
                    acContentItem.removeClass("hide").addClass("hide");
                }                
            }

            //reset the selected  chart
            if (me.settings.menu.top.charts.enabled) me._setChartMenuItem(me.vcMenu.menu.top.charts.find("#btn-" + me.status.menu.selectedChart));

            //reset the dates
            me.vcMenu.menu.main.date.vcOptionBox("setIndex", me.status.date.isSingle ? 0 : 1);
            me._updateDateBox(true); 

            //reset the date comparisons
            if (me.settings.menu.main.dateComparison.enabled) {
                obj = me.vcMenu.menu.main.dateComparison;
                if (me.status.date.dateComparisonType == -1) {
                    obj.find(".button-toggle").removeClass("button-toggle-active");
                    obj.find("#div-no-date-comparison").show();
                    obj.find(".content").hide();
                } else {
                    me.vcMenu.menu.main.dateComparison.vcOptionBox("setIndex", me.status.date.dateComparisonType);
                    obj.find("#div-no-date-comparison").hide();
                    obj.find(".content").show();
                }

                me.vcMenu.menu.main.specificIntervalCompare.val(me.status.date.flexibleInterval);
                me.vcMenu.menu.main.specificDateCompare.vcDate("destroy");
                me.vcMenu.menu.main.specificDateCompare.vcDate({
                    mode: "Range", align: "center", interval: 1, defaultRange: me.status.date.dateRangeComparison, langID: me.settings.userLangIDForCulture, callback: function (obj) {
                        me.status.date.dateRangeComparison = JSON.parse(JSON.stringify(obj.dateRange));
                        me._trigger("MenuChanged", true);
                    }
                })
            }
            //reset the chart style type
            if (me.settings.menu.main.rampOptions.enabled) me._setChartTypeButton(me.status.menu.chartType);

            //reset the user options
            objArchSettings._setUserOptions(me);

            me._trigger("ReloadDirty", true);

        } catch (e) { me._writeErr(e); }

    },

    _updateButtonStatus: function (buttons, filterArray) {
        /// <summary>
        /// This function sets the button activity status of the dc filter buttons
        /// </summary>
        var me = this;
        try {
            buttons.removeClass("button-toggle-active");
            if (filterArray.length > 0) {
                $.each(filterArray, function (_, filterIndex) {
                    buttons.filter(function () {
                        return parseInt($(this).data("index")) === filterIndex;
                    }).addClass("button-toggle-active");
                });
            }
        } catch (e) { me._writeErr(e); }
    },

    //#endregion


    //#region "data"


    _showArchiveLoading: function () {
        var me = this;
        try {
            // we show a loading icon for datacenter start
            if (!me.specific || !me.specific.DataCenterStart) return;

            me.status.isArchiveLoading = true;

            // we only change the opacity and pointer events of the main content, but not of the menu, to allow users to e.g. cancel loading or change settings while loading
            me.fnd("#m-wrapper,#s-wrapper,#my-content").css({ opacity: 0, "pointer-events": "none" });

            if (me.vcMenu && me.vcMenu.selection && me.vcMenu.selection.entries && me.vcMenu.selection.entries.info) {
                me.vcMenu.selection.entries.info.hide();
            }

            me.fnd("#archive-loading").show();
        } catch (e) { me._writeErr(e); }
    },

    _hideArchiveLoading: function () {
        var me = this;
        try {
            if (!me.specific || !me.specific.DataCenterStart) return;

            me.status.isArchiveLoading = false;

            me.fnd("#archive-loading").hide();
            me.fnd("#m-wrapper,#s-wrapper,#my-content").css({ opacity: 1, "pointer-events": "" });

            me._toggleView();

        } catch (e) { me._writeErr(e); }
    },



    _fetchData: function () {
        /// <summary>
        /// This function fetches all signals and fills the signal list and tree menu
        /// </summary>
        var me = this;
        try {
            var filter = me.ready; // if me.ready is false - at the initialization of the archive - some filtering shall not be executed yet
            me._showArchiveLoading();

            var typeid = -1;
            if (me.status.dirty.signals && !me.status.dirty.treeMenu) { typeid = 1 }
            if (!me.status.dirty.signals && me.status.dirty.treeMenu) { typeid = 2 }
            if (me.status.dirty.signals && me.status.dirty.treeMenu) { typeid = 3 }

            


            me.getData({ typeid: typeid, MenuId: me.status.treeMenuId, showArchiveRules: me.settings.showArchiveRules, ChartType: me.settings.defaultChart }, function (result) {

                if (result == null) { me.showMessage(me.resources.err_loadData, true); return true; }
                //parse the signal list

                if (result.Signals !== null) {
                    me.signals = JSON.parse(result.Signals);
                    if (me.signals.length == 0) {
                        me._hideArchiveLoading();
                        me.showMessage(me.resources.noEntriesExist, false);
                        me.fnd("#m-wrapper,#s-wrapper, #my-content").hide();
                        return false;
                    }

                    // filter only if me.ready is already true
                    me._fillSignalList(filter);
                    me.status.dirty.signals = false;

                    if (me.settings.menu.top.datatype.showDetails || me.settings.defaultChart == "docu" || me.settings.defaultChart == "config") {                        
                        if (result.Details == null) { me.showMessage(me.resources.err_loadData, true); return false; }
                        me.details = JSON.parse(result.Details);
                        me.status.dirty.details = false;
                        if (me.status.menu.showDetails) objSignalDetails._showDetails(me);
                    }
                }

                me._fillTreeMenu();

            });            

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _fillSignalList: function (filter) {
        /// <summary>
        /// This function builds a vc-list with the fetched signals - just html strings, nothing complicated  <br/>
        /// </summary>
        var me = this;

        try {

            if (me.error) { return false; }

            var obj = me.vcMenu.selection.entries.signals;

            obj.removeClass("signal-list").addClass("signal-list");

            obj.html(me.vcC.getLoadingIcon());

            var lst = $("<ul>").attr("id", "lst-signal");
            var item, col, col1, elem0, elem1, elem2, elem3, elemLeftOpt, elemRightOpt, resolution, divRes;

            me.status.signals.temperatureBsaid = -1;

            $.each(me.signals, function (key, row) {

                //find the outside temperature
                if (row.bstypeid == 3) me.status.signals.temperatureBsaid = row.id;


                item = $("<li>").attr("id", "bsaid" + row.id).data("id", row.id).data("interval", row.allowedinterval).data("tags", row.tags).data("valTags", row.valTags);
                item.addClass("vc-list-item tagFound");
                if (row.isarchiverule === false) { item.addClass("isSignal") } else { item.addClass("isRule") }
                if (row.dataflow !== null) item.addClass("contains-sub-signals");
                if (row.haszst) item.addClass("has-zst");
                //calculate raw-data resolution
                resolution = 0; 
                if (row.hr_resolution > 0) {
                    resolution = (row.hr_resolution / 60);
                } else {
                    if (row.hr_based) { resolution = 15; }
                }
                if (resolution > 0) item.addClass("contains-rawdata");

                //handle left part
                col = $("<div>").addClass("vc-list-col vc-list-col-half col-left");
                elem0 = $("<div>").addClass("vc-list-col-element col0");
                elem1 = $("<div>").addClass("vc-list-col-element col1");

                // add to list of summable signals for ds filtering
                if (row.bissum) {
                    me.status.dcFilters.additionalTypes.allSummables.push(row.id); 
                    elem0.addClass(" bissum");
                }
                else 
                    me.status.dcFilters.additionalTypes.allNotSummables.push(row.id); 

                // add to list of not delayed or imported signals for ds filtering
                if (row.validationdelay > 0 || row.longtermdelay > 0) { me.status.dcFilters.additionalTypes.allDelayed.push(row.id); } else { me.status.dcFilters.additionalTypes.allOnTime.push(row.id); }
                if (me.status.dcFilters.fileImportList.includes(row.blhnid)) { me.status.dcFilters.additionalTypes.allImported.push(row.id); } else { me.status.dcFilters.additionalTypes.allNotImported.push(row.id); }

                if ((row.name + + " [" + row.dims + "]").length > 30) {
                    elem0.addClass("small-font");
                }

                if (row.isarchiverule === false) {
                    elem0.append($("<div>").addClass("dc-icons"));                         

                    elem0.append($("<i>").addClass("fa fa-eye-slash icon-color-ok").attr("title", me.specific.resources.notAllowedInterval), divRes, row.name + " [" + row.dims + "]");
                    elem0.append($("<div>").addClass("ac-info").attr("title", "AutoCheck (" + me.specific.resources.count + "): " + me.specific.resources.active + "/" + me.specific.resources.rule + " - " + me.specific.resources.dataEditing));

                    if (me.settings.selection.entries.signals.showIcons) {

                        if (row.internal) {
                            elem0.append(me.specific.resources.internal);
                            me.status.dcFilters.additionalTypes.allInternals.push(row.id); // add to list of internal signals for ds filtering
                        }
                        else
                            me.status.dcFilters.additionalTypes.allPublics.push(row.id); // add to list of public signals for ds filtering

                        if (resolution > 0) {
                            elem1.append($("<div>").addClass("info-hr color-font-secondary").attr("title", me.specific.resources.rawDataResolution).html(resolution + " min"));
                        }

                        let obj = me.settings.selection.entries.signals.charts;
                        // add additional icons for loading sub charts
                        $.each(me.settings.iconCharts, function (i, item) {
                            if (item.enabled &&
                                ((item.zstOnly && row.haszst && obj.showMeterReadings) || (item.dataflowOnly && row.dataflow !== null && obj.showDataFlow) || (item.alarmOnly && row.alarm)
                                    || (!item.zstOnly && !item.dataflowOnly && !item.alarmOnly))
                            ) {
                                elem1.append($("<i>").data("type", item.id).addClass("vc-list-icon popup color-font-secondary").addClass(item.icon).attr("title", item.name));
                            }
                        });

                        /*if (me.settings.userRights.showTicket) */elem1.append($("<i>").data("type", "TICKET").addClass("vc-list-icon ticket popup fa-regular fa-ticket color-font-secondary").attr("title", me.specific.resources.ticket));
                    }


                    elem1.append($("<i>").data("type", "SIGNALINFO").addClass("vc-list-icon popup fa-regular fa-info-circle color-font-secondary").attr("title", me.specific.resources.signalInfo));

                } else {
                    elem0.append(row.name);
                    if (row.dims.length === 0) {
                        // elem0.append("-");
                    } else {
                        elem0.append(" [" + row.dims + "]");
                    }

                }

                var elemPlausOpt = $("<div>").addClass("vc-list-col-element col-opt-plaus");
                elemLeftOpt = $("<div>").addClass("vc-list-col-element col-opt");

                col.append(elem0, elem1);

                // check if plaus shall be shown - for admins, plaus shall be always shown except Plaus-4-None; for normal users, plaus shall only be shown for signals, which are already tagged
                var showPlaus = me.settings.userRights.isAdmin ? !row.valTags.includes("Plaus-4-None") : !row.valTags.includes("Plaus-4-None") && row.valTags.includes("Plaus-");

                // plaus optional info shall be only shown, if signal is not archiverule and has no tag "Plaus-4-None"
                if (!row.isarchiverule && showPlaus) col.append(elemPlausOpt); 
                col.append(elemLeftOpt);

                //handle right part
                col1 = $("<div>").addClass("vc-list-col vc-list-col-half col-right");
                elem2 = $("<div>").data("type", "TAGS").addClass("vc-list-col-element col2");
                elem2.append(me.vcC.expandTags(row.tags));
               
                //add the equipment tags
                // sTmp += me.vcC.expandTags(row.equiptags);

                elem3 = $("<div>").addClass("vc-list-col-element col3");
                if (row.hardware !== null && row.protocol !== null && row.host !== null) {

                    me.status.dcFilters.signalTypes.allOnlyMeasures.push(row.id); // add to list of measures for ds filtering

                    var sHw = row.protocol + "(" + row.hardware + ")@" + row.unitname;
                    if ((row.host + ":" + row.port) != "0:0") {
                        sHw += "<br/>" + row.host + ":" + row.port;
                    }
                    elem3.data("blhid", row.blhid).html(sHw + " <span>" + row.blhid + "</span><span style='display:none'>blhid" + row.blhid + "</span>");
                } else {
                    if (row.isarchiverule === false) {
                        if (row.issignalrule) {
                            me.status.dcFilters.signalTypes.allOnlyRules.push(row.id); // add to list of signal rules for ds filtering
                            elem3.html(me.specific.resources.virtual);
                        }
                    } 
                }
                elemRightOpt = $("<div>").addClass("vc-list-col-element col-opt");

                col1.append(elem2, elem3, elemRightOpt);
                item.append(col, col1);

                lst.append(item);
            });


            obj.html(lst);
            obj.find(".vc-list-item:odd").addClass("alt");

            // do not call at initialization, because it is called directly afterwards in fillTreeMenu
            if(filter)
                me._filter();

            // get all open tickets to set the ticket icon for each signal correctly
            objSignalTickets._fetchOpenTickets(me);

            return true;
        } catch (ex) { me._writeErr(ex); return false; }
    },

    _filter: function () {
        /// <summary>
        /// This function filters the tags based on a given menu filter and filters the complete content of the signal list based on the vcFilter  <br/>
        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }
            if (me.status && me.status.isArchiveLoading) return true;

            me.vcMenu.selection.entries.wrapper.hide();

            //hide all
            me.visual.find("#lst-signal li.vc-list-item").removeClass("tagFound menuFilterFound").data("counter", 0).hide();

            // convert selTagBsaids to real array
            if (me.selTagBsaids.length > 0 && typeof me.selTagBsaids === "string") {
                me.selTagBsaids = me.selTagBsaids.replace(/[\[\]\s]+/g, '').split(',').map(function (id) {
                        return parseInt(id, 10);  
                    });
            }                       
            
            //first we filter all signals with the tag we got from the vc-tree-menu
            //if (me.status.menuFilter.length > 0) {
            if (me.selTagBsaids.length > 0) {

                me.visual.find('#lst-signal li.vc-list-item').filter(function () {
                    var item = $(this);
                    var itemId = parseInt(item.data("id"), 10);
                    if (me.selTagBsaids.includes(itemId)) {
                        item.addClass("menuFilterFound");
                    }
                });

                //if (me.status.menuFilter !== 'no_assigned_tags' && me.status.menuFilter !== 'has_ticket') {
                //    me.visual.find('#lst-signal li.vc-list-item').filter(function () {

                //        var item = $(this);

                //        switch (me.status.treeMenuId) {
                //            case 0: //tags in vcTreeMenu
                //                //see if we find a system tag


                //                if ($(this).find("." + me.settings.selection.entries.signals.cssClassTagsCol + " .vc-tags-item-system").html() === me.status.menuFilter) {
                //                    item.addClass("menuFilterFound");
                //                    return true;
                //                }
                //                var tags;
                //                //split all tags and find the tag we are looking for
                //                //why split the title? in the title we find the complete hierarchical tag eg: building / first floor / section 1
                //                //if we won't search the title we would only find all 'section 1' tags but no 'building' or 'first floor'
                //                $(this).find("." + me.settings.selection.entries.signals.cssClassTagsCol + " .vc-tags-item").each(function () {
                //                    tags = $(this).attr("title").split(" / ");
                //                    for (var i = 0; i <= tags.length - 1; i++) {
                //                        if (tags[i] === me.status.menuFilter) {
                //                            item.addClass("menuFilterFound");
                //                            return true;
                //                        }
                //                    }
                //                    // ReSharper disable once NotAllPathsReturnValue
                //                });
                //                break;


                //            case 1: //hardware in vcTreeMenu
                //                var xcol = item.find("." + me.settings.selection.entries.signals.cssClassHwCol);
                //                if (xcol.length > 0) {
                //                    var col3 = xcol.html();
                //                    col3 = col3.replace("<span>", "").replace("</span>", "");
                                  
                //                   //the last part of the menu filter is 
                //                    var lstMenuFilter = me.status.menuFilter.split(" ");
                //                    if (lstMenuFilter.length > 1) {

                //                        //console.info("filter: blhid" + lstMenuFilter[lstMenuFilter.length - 1]);
                //                        if (col3.indexOf("blhid" + lstMenuFilter[lstMenuFilter.length - 1]) >= 0) { item.addClass("menuFilterFound"); return true; }
                //                    } else {
                //                        if (col3.indexOf(me.status.menuFilter) >= 0) { item.addClass("menuFilterFound"); return true; }
                //                    }

                //                }
                //                return false;
                //                break;
                //        }

                //        return false;
                //    });
                //} else {
                //    if (me.status.menuFilter === 'no_assigned_tags') {
                //        //we have to find every signal which have no tags assigned (except the vc-tags-item-system which every item gets automatically)
                //        me.visual.find('#lst-signal li.vc-list-item').filter(function () {
                //            return $(this).find("." + me.settings.selection.entries.signals.cssClassTagsCol + " .vc-tags-item").not(".vc-tags-item-system").length === 0;
                //        }).addClass("menuFilterFound");
                //    }
                //    if (me.status.menuFilter === 'has_ticket') {
                //        //we have to find every signal which have no tags assigned (except the vc-tags-item-system which every item gets automatically)
                //        me.visual.find('#lst-signal li.vc-list-item').filter(function () {
                //            return $(this).find(" .fa-ticket").css("opacity") === "1";
                //        }).addClass("menuFilterFound");
                //    }


                //}

            } else {
                //if selTagBsaids is empty, no item is found
                 me.visual.find("#lst-signal li.vc-list-item").removeClass("menuFilterFound");
            }



            //we add the 'found' class to all items we want to filter based on the vcfilter tags
            me.setTagFilter(".vc-filter", "#lst-signal li.vc-list-item", "tagFound");


            //toggle the signal and meta list based on the allowed interval
            if (me.settings.enableFilterForInvalidSignals) {
                me.visual.find("#lst-signal li.vc-list-item").removeClass("notAllowedInterval").filter(function () { return $(this).data("interval") > me.status.menu.interval }).addClass("notAllowedInterval");

            }            


            if (me.status.menu.interval === 1 && (me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart)) {

                // first we check if any dc filter regarding the signal type (measure, rule, etc) is active and filter the corresponding signals
                if (me.status.dcFilters.filterLists.activeTypeFilters.length > 0)
                    objDataCenter._applyDcFiltering(me, me.status.dcFilters.filterLists.activeTypeFilters, me.status.dcFilters.filterLists.typeFilteredSignals);

                // now we check if dc filter is active (invalid, unplausible, etc.) and filter the remaining signals
                if (me.status.dcFilters.filterLists.activeValFilters.length > 0)
                    objDataCenter._applyDcFiltering(me, me.status.dcFilters.filterLists.activeValFilters, me.status.dcFilters.filterLists.valFilteredSignals);


                if (me.status.dcFilters.filterLists.activeAddFilters.length > 0)
                    objDataCenter._applyDcFiltering(me, me.status.dcFilters.filterLists.activeAddFilters, me.status.dcFilters.filterLists.addFilteredSignals);

                if (me.status.dcFilters.filterLists.activePlausFilters.length > 0)
                    objDataCenter._applyDcFiltering(me, me.status.dcFilters.filterLists.activePlausFilters, me.status.dcFilters.filterLists.plausFilteredSignals);

                if (me.status.dcFilters.filterLists.activeAutoCheckFilters.length > 0)
                    objDataCenter._applyDcFiltering(me, me.status.dcFilters.filterLists.activeAutoCheckFilters, me.status.dcFilters.filterLists.autoCheckFilteredSignals);


                // check if error filters are active, to update the errors in the vcTreeMenu3
                me._updateErrorInfo();
                   
            }
           
            me.visual.find("#lst-signal li.vc-list-item.tagFound.menuFilterFound").show();


            me.visual.find("#lst-signal li.vc-list-item").removeClass("alt");
            me.visual.find("#lst-signal li.vc-list-item.tagFound.menuFilterFound:even").addClass("alt");

            if (me.visual.find("#lst-signal li.vc-list-item.tagFound.menuFilterFound").length === 0 ) {
                me.visual.find("#s-entries .vc-list-table").hide();
                me.visual.find("#entry-info").html(me.resources.noEntriesExist).show();
                me.visual.find(".vc-list.signal-list").css("overflow-y", "hidden");

            } else {
                me.visual.find("#s-entries .vc-list-table").show();
                me.visual.find("#entry-info").hide();
                me.visual.find(".vc-list.signal-list").css("overflow-y", "auto");

            }

            //handle selection
            me._makeSignalSelectionInFilter();

            if (me.status.dataLoaded) {
                me.vcMenu.selection.entries.wrapper.show();
                me.vcMenu.selection.entries.signals.show();
            }

            //now we are ready to go
            return true;
        } catch (ex) {
            me._writeErr(ex);
            return false;
        }

    },

    _updateErrorInfo: function () {
        var me = this;

        try {
            // check if error filters are active, to update the errors in the vcTreeMenu3
            if ($('.vctree-menu-3').length > 0) {
                var allFilteredSignals = [];
                var anyFilterActive = false;

                if (me.status.dcFilters.filterLists.activeValFilters.length > 0) {
                    anyFilterActive = true;

                    for (var i = 0; i < me.status.dcFilters.filterLists.activeValFilters.length; i++) {
                        var index = me.status.dcFilters.filterLists.activeValFilters[i];
                        var foundSignals = me.status.dcFilters.filterLists.valFilteredSignals[index];
                        allFilteredSignals = allFilteredSignals.concat(foundSignals);
                    }
                }


                allFilteredSignals = [...new Set(allFilteredSignals)]; // get all filtered signals (with errors) for correct error counting

                me.vcMenu.selection.treeMenu.list.vcTreeMenu3("updateErrors", allFilteredSignals, anyFilterActive, me.status.menu.interval, me.status.date.isSingle);
            }
        } catch (e) { me._writeErr(e); }

    },

    _getTreeMenuStartIndex: function () {
        var me = this;
        try {
            var startIndex = 0;

            switch (me.status.treeMenuId) {
                case 0: // tags
                    startIndex = 1;
                    break;
                case 1: // hardware
                    startIndex = 1;
                    break;
                case 2: // tickets
                    startIndex = 0;
                    break;
                default:
                    break;
            }

            return startIndex;
        } catch (e) { me._writeErr(e); }
    },

    _fillTreeMenu: function () {
        /// <summary>
        /// This function fetches the data we want to copy based on the copy menu
        /// </summary>
        var me = this;
        try {

            if (!me.error) {

                if (!me.settings.selection.treemenu.enabled) { return true; }

                me.status.dataLoaded = false;
                me.vcMenu.selection.treeMenu.list.html(me.vcC.getLoadingIcon());

                me.vcMenu.selection.treeMenu.list.attr("id", "vc-tree-" + me.vcgid);     

                me.vcMenu.selection.treeMenu.list.vcTreeMenu3({
                    parameter: { loggerId: me.specific.LoggerId },
                    dataModel: me.status.treeMenuId,
                    day: me.status.menu.endDate,
                    selInterval: me.status.menu.interval,
                    useCachedData: me.status.treeMenuStatus[me.status.treeMenuId] != undefined,
                    cachedTreeData: me.status.treeMenuStatus[me.status.treeMenuId],
                    invokeType: "addVisualContent",
                    "vcgid": me.vcgid,
                    "h": me.vcMenu.selection.treeMenu.list.height(), // parseInt(me.vcMenu.selection.treeMenu.list.outerHeight(true)) + 10,
                    "w": parseInt(me.vcMenu.selection.treeMenu.wrapper.width()),
                    startIndex: me._getTreeMenuStartIndex(), // we get the start index for the currently selected menu button
                    chartType: me.settings.defaultChart,
                    //"data": me.treeMenu,
                    "clearFilter": true,
                    "showNotAssigned": false,
                    "showAllAtStart": me.settings.showAllSignalsAtStart,
                    "callback": function (e) {
                        switch (e.type) {
                            case "init":
                                me.status.dataLoaded = true;
                                //me.status.menuFilter = e.value;
                                me.status.dirty.treeMenu = false;  

                                if (me.status.treeMenuStatus[me.status.treeMenuId] != undefined) {
                                        me.vcMenu.selection.treeMenu.list.vcTreeMenu3("loadTreeState", me.status.treeMenuStatus[me.status.treeMenuId]);
                                }


                                // when both lists are loaded, stop loading and notify outer widget
                                if (!me.status.dirty.signals && !me.status.dirty.treeMenu) {
                                    me._hideArchiveLoading();

                                    // optional, but recommended: tells MultipleArchives it can show the archive again
                                    me.vcMenu.obj.trigger('loadingFinished', { done: true });
                                }


                                break;
                            case "update":
                                me.selTagBsaids = [];
                                me.selTagBsaids = e.value;
                                me._filter();
                                me._reload();
                        }

                        //if (e.type === "update")
                        //    console.log(e.value);
                        //else
                        //    console.log("no bsaids");
                    }
                });                
               
            }

        } catch (e) { me._writeErr(e); return false; }
    },

    _toggleTreeMenu: function () {
        /// <summary>
        /// This function toggles the tree menu buttons to switch between tags and hardware
        /// </summary>
        var me = this;
        try {
            let btns = me.vcMenu.selection.treeMenu.button.find(".button-toggle");

            btns.off("click").on("click", function () {
                // check if vcTreeMenu3 is initialized
                if ($('.vctree-menu-3').length > 0) {
                    if (me.vcMenu.selection.treeMenu.list.vcTreeMenu3("getInitializedState")) {

                        // save current treeMenu state before switching to other menu button
                        delete me.status.treeMenuStatus[me.status.treeMenuId];
                        me.status.treeMenuStatus[me.status.treeMenuId] = me.vcMenu.selection.treeMenu.list.vcTreeMenu3("saveTreeState");

                        btns.removeClass("button-toggle-active");
                        $(this).addClass("button-toggle-active");
                        me.status.treeMenuId = parseInt($(this).data("menuid"));
                        me.status.dirty.treeMenu = true;

                        me.vcMenu.selection.treeMenu.list.html(me.vcC.getLoadingIcon());
                        me._fetchData();
                    }
                }
            }).button();

        } catch (e) { me._writeErr(e); }

    },  

    _setTreeMenuButtons: function () {
        /// <summary>
        /// This function sets the desired button active according to treeMenuId
        /// </summary>
        var me = this;
        try {
            var btns = me.vcMenu.selection.treeMenu.button.find(".button-toggle").removeClass("button-toggle-active");
            $(btns[me.status.treeMenuId]).addClass("button-toggle-active");
        } catch (e) { me._writeErr(e); }
    },
    

    //#endregion


    //#region "signal selection"

    _getAllSelectedList: function () {
        /// <summary>
        /// This function returns the currently selected signal list <br/>
        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }
            switch (me.status.choiceListType) {
                case 0: return me.status.signals.allSelectedBsaids;
                case 1: return me.status.signals.allSelectedMeta;
            }
            return true;
        } catch (ex) { me._writeErr(ex); return false; }
    },

    _setAllSelectedList: function (lst) {
        /// <summary>
        /// This function updates currently selected signal list <br/>
        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }
            switch (me.status.choiceListType) {
                case 0: {
                    me.status.signals.allSelectedBsaids = lst;

                    break;
                }
                case 1: {
                    me.status.signals.allSelectedMeta = lst; break;
                }

            }
            return true;
        } catch (ex) { me._writeErr(ex); return false; }
    },

    _toggleChoiceListMenu: function () {
        var me = this;
        try {

            let btns = me.vcMenu.selection.choice.caption.find(".button-toggle");

            btns.off("click").on("click", function () {
                btns.removeClass("button-toggle-active");
                $(this).addClass("button-toggle-active");
                me.status.choiceListType = parseInt($(this).data("choiceListId"));
                me._markSelectedSignals();
            }).button();

        } catch (e) { me._writeErr(e); }

    },

    _clearChoiceList: function () {
        /// <summary>
        /// This function removes all items from the allSelectedBsaids list and clears selected signals <br/>

        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }

            me._setAllSelectedList([]);
            me.visual.find("#lst-signal li.vc-list-item").removeClass("selected");
            me._getSelectedSignals();

            return true;
        } catch (ex) { me._writeErr(ex); return false; }
    },

    _removeItemFromChoiceList: function (obj) {
        /// <summary>
        /// This function removes one single item from the choice list <br/>

        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }

            me._setAllSelectedList(me._getAllSelectedList().filter(function (elem) { return elem != obj.data("id"); }));
            me.visual.find('#lst-signal li.vc-list-item').filter(function () { return $(this).data("id") == obj.data("id"); }).removeClass("selected");
            me._getSelectedSignals();

            return true;
        } catch (ex) { me._writeErr(ex); return false; }
    },

    _makeSignalSelectionInFilter: function () {
        /// <summary>
        /// This function adds the initially selected signals to the selected-list<br/>
        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }

            if (me.status.dataLoaded && !me.status.firstChoiceFilled && me.status.signals.allSelectedBsaids.length == 0 && !me.status.madeSelection) {

                if (typeof (me.options.parameter.SelectedBsaids) !== "undefined") {
                    me.status.signals.allSelectedBsaids = me.options.parameter.SelectedBsaids;
                } else {

                    me.status.signals.allSelectedBsaids = [];
                    $.each(me.visual.find("#lst-signal .vc-list-item.tagFound.menuFilterFound"), function () {
                        if (me.status.signals.allSelectedBsaids.indexOf($(this).data("id")) < 0) me.status.signals.allSelectedBsaids.push($(this).data("id"));
                    });
                }

            }
            me._markSelectedSignals();

            return true;
        } catch (ex) { me._writeErr(ex); return false; }

    },

    _markSelectedSignals: function () {
        /// <summary>
        /// This function marks all selected signals from the currently selected list <br/>
        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }

            me.visual.find("#lst-signal .vc-list-item").removeClass("selected");

            if (me.settings.signalSelection) {

                $.each(me._getAllSelectedList(), function () {
                    var id = this;
                    me.visual.find("#lst-signal li.vc-list-item").filter(function () { return $(this).data("id") == id }).addClass("selected");
                });

            }

            me._getSelectedSignals();

            return true;
        } catch (ex) { me._writeErr(ex); return false; }

    },

    _selectEntry: function (obj) {
        /// <summary>
        /// This function handles the select/unselect functionality for the signal  list <br/>

        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }
            if (me.status.showContent && obj.hasClass("notAllowedInterval")) return false;


            me.status.madeSelection = true;

            if (obj.hasClass("selected")) {
                obj.removeClass("selected");
                me._setAllSelectedList(me._getAllSelectedList().filter(function (elem) { return elem != obj.data("id"); }));
            } else {
                obj.addClass("selected");
                if (me._getAllSelectedList().indexOf(obj.data("id")) < 0) me._getAllSelectedList().push(obj.data("id"));
            }


            me._getSelectedSignals();

            if (me.status.showContent) me._loadContent(me.status);

            return true;
        } catch (ex) { me._writeErr(ex); return false; }
    },

    _selectAll: function (lst, add) {
        /// <summary>
        /// This function handles the select/unselect functionality for the signal and the meta types list <br/>
        /// the setChb parameter is only used to handle the checkbox in the meta type list
        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }
            me.status.madeSelection = true;

            if (add) {

                $.each(me.visual.find("#lst-signal .vc-list-item.tagFound.menuFilterFound"), function () {
                    if (me._getAllSelectedList().indexOf($(this).data("id")) < 0) me._getAllSelectedList().push($(this).data("id"));
                });
                me.visual.find("#" + lst + " li").addClass("selected");
            } else {
                $.each(me.visual.find("#lst-signal .vc-list-item.tagFound.menuFilterFound"), function () {
                    var id = $(this).data("id");
                    me._setAllSelectedList(me._getAllSelectedList().filter(function (elem) { return elem != id; }));
                });
                me.visual.find("#" + lst + " li").removeClass("selected");
            }

            me._trigger("ReloadDirty", true);
            me._getSelectedSignals();

            return true;
        } catch (ex) { me._writeErr(ex); return false; }
    },
    

    _getSelectedSignals: function () {
        /// <summary>
        /// This function generates a list of visible, all selected (even those with not-allowed-interval) and selected bsaids every time a signal changes
        /// </summary>
        var me = this;
        try {

            if (!me.error) {

                me.status.signals.selectedBsaids = me._fillSelectedList(me.status.signals.allSelectedBsaids);
                me.status.signals.selectedMeta = me._fillSelectedList(me.status.signals.allSelectedMeta);

                if (me._getAllSelectedList().length == 0) {
                    me.vcMenu.selection.choice.list.html($("<div>").addClass("note").html(me.specific.resources.noSelectionWasMade));
                    //update the signal counter in the choice header
                    me.fnd(".span-choice-signal-counter-" + me.status.choiceListType).html(0);
                    return true;
                }

                var lst = $("<ul>").attr("id", "lst-choice");
                me.vcMenu.selection.choice.list.html(lst);




                $.each(me._getAllSelectedList(), function () {
                    let bsaid = this;
                    let signal = me.signals.filter(function (item) { return item.id == bsaid })[0];
                    let item = $("<li>").addClass("vc-list-item").html($("<div>").addClass("vc-list-col"));
                    let elem = $("<div>").addClass("vc-list-col-element").html("");
                    if ((signal.name + + " [" + signal.dims + "]").length > 30) { elem.addClass("small-font"); }
                    if (signal.allowedinterval > me.status.menu.interval) {
                        item.addClass("notAllowedInterval");
                        elem.append($("<i>").addClass("fa fa-eye-slash icon-color-ok").attr("title", me.specific.resources.notAllowedInterval), " ");
                    }
                    elem.append(signal.name);
                    if (signal.dims != "") elem.append(" [" + signal.dims + "]");

                    elem.append($("<i>").data("id", bsaid).addClass("choice-clear-single fa fa-times vc-list-icon icon-color-error").attr("title", me.specific.resources.removeFromList));
                    lst.append(item.append(elem));

                });
                lst.find("li.vc-list-item:even").addClass("alt");

                //update the signal counter in the choice header
                me.fnd(".span-choice-signal-counter-" + me.status.choiceListType).html(lst.find("li.vc-list-item").length);
            }

        } catch (ex) { me._writeErr(ex); }
    },

    _fillSelectedList: function (lstAll) {
        /// <summary>
        /// This function generates a list of selected bsaids every time a signal changes
        /// </summary>
        var me = this;
        try {

            if (!me.error) {
                var lst = [];
                $.each(lstAll, function () {
                    let bsaid = this;
                    let signal = me.signals.filter(function (item) { return item.id == bsaid })[0];
                    if (signal.allowedinterval <= me.status.menu.interval) { lst.push(this); }
                });
                return lst;
            }
        } catch (ex) { me._writeErr(ex); return [] }
    },

    //#endregion




    //#region "state handling"

    _reload: function () {
        var me = this;
        try {

            if (!me.error) {
                // TODO MKU: disabled for the moment for new release! enable again!
                //me.vcMenu.menu.main.button.find("#btn-reload").addClass("inactive").removeClass("active");
                //me.vcMenu.menu.main.button.find("#btn-select").addClass("inactive").removeClass("active");

                // check if vcTreeMenu3 is initialized before calling getUpdatedErrorData
                if ($('.vctree-menu-3').length > 0) {
                    me.vcMenu.selection.treeMenu.list.vcTreeMenu3("getUpdatedErrorData", me.status.menu.startDate);
                }

                objDataCenter._clearDcFiltering(me);

                if (me.status.dirty.signals || me.status.dirty.treeMenu) {
                    me._fetchData();

                } else {
                    me._toggleView();
                    me._loadContent(me.status);
                }

                me._trigger("ReloadDirty", false);

                //me.vcMenu.selection.entries.menu.dcFilter.hide();
                //me.vcMenu.selection.entries.menu.dcFeatures.hide();
                //me.vcMenu.selection.entries.menu.dcFilterBox.hide();
                //me.vcMenu.selection.entries.menu.dcBtnReset.hide();
                                

                // dc filter only visible if data center is activated
                if (me.signals != null) objDataCenter._fetchDcData(me); 

                // TODO MKU: check if this works for every case
                if (!((me.status.menu.activateDataCenter || me.specific.DataCenterStart) && me.status.menu.interval === 1)) {
                    me.vcMenu.selection.entries.menu.dcFilter.hide();
                    me.vcMenu.selection.entries.menu.dcFeatures.hide();
                    me.vcMenu.selection.entries.menu.dcFilterBox.hide();
                    //me.vcMenu.selection.entries.menu.dcBtnReset.hide();
                }

                if (me.status.menu.showDetails) objSignalDetails._showDetails(me);

                if (me.status.menu.interval === 1) {
                    objSignalPlaus._showPlausInfo(me);
                }
                else { objSignalPlaus._hidePlausInfo(me); }                   

                // TODO MKU: disabled for the moment for new release! enable again!
                //if (!me.status.menu.activateDataCenter) {
                //    me.vcMenu.menu.main.button.find("#btn-reload").addClass("active").removeClass("inactive");
                //    me.vcMenu.menu.main.button.find("#btn-select").removeClass("active").removeClass("inactive").addClass("active");
                //}                
            }

        } catch (e) { me._writeErr(e); }
        return true;
    },

    _loadContentWithoutReloadButton: function () {
        /// <summary>
        /// if we have no reload and selection button we have to reload the content automatically
        /// we do it only if we already got signals and the tree menu.
        /// </summary>
        var me = this;
        try {

            if (!me.settings.toggleView || !me.settings.menu.main.button.enabled) {
                if (!me.status.dirty.signals && !me.status.dirty.treeMenu && me.signals !== null) {
                    me._loadContent(me.status);
                }

            }
        } catch (e) { me._writeErr(e); }
    },


    _toggleReloadButtonState: function () {
        var me = this;
        try {

            let obj = me.vcMenu.menu.main.button;
            obj.find("#btn-reload-icon").removeClass("fa-check").addClass("fa-sync-alt");
            obj.find("#btn-reload-caption").html(me.specific.resources.reload);

        } catch (e) { me._writeErr(e); }
    },

    _toggleView: function () {
        /// <summary>
        /// shows/hides the content or the selection list
        /// </summary>
        var me = this;
        try {

            //we only activate favorites and share when we show the content
            me.vcMenu.menu.top.exportBtn.find("#btn-export-menu").toggleClass("inactive", !me.status.showContent);

            //we toggle the visibility of the option box depending on the showContent status, if specified for the current subchart
            if (me.status.toggleOptionBoxVisibility)
                me.vcMenu.menu.main.rightWrapper.find("#m-specific-options").toggleClass("inactive", !me.status.showContent);

            if (me.status.showContent) {
                me.vcMenu.selection.wrapper.hide();
                me.vcMenu.content.show();

            } else {
                me.vcMenu.selection.wrapper.show();
                me.vcMenu.content.hide();

            }

            //we set specific heights  - yes - it's a hack, but otherwise we get the wrong height when we start the first chart - I don't know why 
            me._setHeights();

        } catch (e) { me._writeErr(e); }

    },

    _toggleOptionBoxVisibility: function () {
        /// <summary>
        /// toggles the visibility of the specific option box depending on the showContent status
        /// </summary> 
        var me = this;
        try {

            if (me.status.showContent)
                me.vcMenu.menu.main.specificOptions.show();
            else
                me.vcMenu.menu.main.specificOptions.hide();
        } catch (e) { me._writeErr(e); }
    },

    //#endregion




    //#region "structure"
    _fillStructure: function () {
        /// <summary>
        /// we build up the structure of the different parts
        /// </summary>
        var me = this;
        try {

            let obj = null;
            let settings = null;

            var smallMenuButtons = (me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart) && me.settings.defaultChart == "archive";

            //add interval menu
            if (me.settings.menu.top.interval.enabled) {
                //init top overview menu
                me.vcMenu.menu.top.overview.list.html("");

                obj = me.vcMenu.menu.top.interval;
                settings = me.settings.menu.top.interval;

                if (me.settings.menu.top.showHeaders) {
                    //obj.append($("<div>").attr("id", "header-interval").addClass("vc-list-header-simple").html(me.specific.resources.period));
                    obj.append(ButtonMenu._setMenuHeader("header-interval", me.specific.resources.period));
                }

                //if (settings.intervals.indexOf(1) > -1) obj.append($("<div>").data("type", 1).addClass("button-toggle interval interval-1").html("<i class='fa fa-calendar-day big-icon'></i><br/>" + me.specific.resources.day));
                //if (settings.intervals.indexOf(3) > -1) obj.append($("<div>").data("type", 3).addClass("button-toggle interval interval-3").html("<i class='fa fa-calendar-days big-icon'></i><br/>" + me.specific.resources.month));
                //if (settings.intervals.indexOf(5) > -1) obj.append($("<div>").data("type", 5).addClass("button-toggle interval interval-5").html("<i class='fa fa-calendar big-icon'></i><br/>" + me.specific.resources.year));

                if (settings.intervals.indexOf(1) > -1) obj.append(ButtonMenu._setSimpleButton("", ["type", 1], "interval interval-1", $("<i>", { class: 'fa fa-calendar-day big-icon' }), me.specific.resources.day, false, "", smallMenuButtons ? 70 : 0));
                if (settings.intervals.indexOf(3) > -1) obj.append(ButtonMenu._setSimpleButton("", ["type", 3], "interval interval-3", $("<i>", { class: 'fa fa-calendar-days big-icon' }), me.specific.resources.month, false, "", smallMenuButtons ? 70 : 0));
                if (settings.intervals.indexOf(5) > -1) obj.append(ButtonMenu._setSimpleButton("", ["type", 5], "interval interval-5", $("<i>", { class: 'fa fa-calendar big-icon' }), me.specific.resources.year, false, "", smallMenuButtons ? 70 : 0));

                if (me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart) obj.find(".interval-5").addClass("no-margin-right");
                 
                //set the default interval
                obj.find(".button-toggle").filter(function () { return parseInt($(this).data("type")) == settings.default }).addClass("button-toggle-active");
                me.status.menu.interval = settings.default;

            }

            //add the data type menu
            if (me.settings.menu.top.datatype.enabled) {
                obj = me.vcMenu.menu.top.dataType;

                if (me.settings.menu.top.showHeaders && me._checkHeaderVisibility(me.settings.menu.top.datatype, "show")) {
                    //obj.append($("<div>").addClass("vc-list-header-simple").html(me.specific.resources.options));

                    obj.append(ButtonMenu._setMenuHeader("", me.specific.resources.options));
                }

                if (me.settings.menu.top.datatype.showAccumulated) obj.append(ButtonMenu._setSimpleButton("btn-accumulated", "", "datatype", $("<i>", { class: 'fa fa-arrow-up-right-dots' }), me.specific.resources.accumulated, false));
                if (me.settings.menu.top.datatype.showSingleValueAsConsumption) obj.append(ButtonMenu._setSimpleButton("btn-15min-consumption", ["optid", 10], "datatype not-allowed-interval-3 not-allowed-interval-5", $("<i>", { class: 'fa fa-sigma' }), me.specific.resources.consumption, false));
                if (me.settings.menu.top.datatype.showFill0) obj.append(ButtonMenu._setSimpleButton("btn-fill0", ["optid", 6], "datatype", $("<i>", { class: 'fa fa-terminal' }), me.specific.resources.fillLeaks, false));
                if (me.settings.menu.top.datatype.showPrice) obj.append(ButtonMenu._setSimpleButton("btn-price", "", "datatype", $("<i>", { class: 'fa fa-coins' }), me.specific.resources.price, false));
                if (me.settings.menu.top.datatype.showCo2) obj.append(ButtonMenu._setSimpleButton("btn-co2", "", "datatype", $("<i>", { class: 'fa-brands fa-envira' }), me.specific.resources.co2, false));
                if (me.settings.menu.top.datatype.showAddTemp) obj.append(ButtonMenu._setSimpleButton("btn-add-temp", ["data-optid", 1], "datatype", $("<i>", { class: 'fa fa-thermometer-full' }), me.specific.resources.temperature, false));
                if (me.settings.menu.top.datatype.showDetails) obj.append(ButtonMenu._setSimpleButton("btn-show-details", "", "datatype", $("<i>", { class: 'fa fa-memo-circle-info' }), me.specific.resources.docu, false));

                // TODO MKU: fast solution to hide header, if no datatype is available; needs to be refactored!!
                var length = obj.find(".datatype").length;
                if (length == 0) {
                    obj.find(".vc-list-header-simple").hide();
                }                        
               
            }

            //add the charts menu
            if (me.settings.menu.top.charts.enabled) {
                obj = me.vcMenu.menu.top.charts;
                if (me.settings.menu.top.showHeaders) {
                    //obj.append($("<div>").addClass("vc-list-header-simple").html(me.specific.resources.charts));

                    obj.append(ButtonMenu._setMenuHeader("", me.specific.resources.charts));
                }
                //add the additional charts

                var chartCounter = 0;

                $.each(me.settings.charts, function () {
                    if (this.enabled) {     
                        var cssClass = "chart-type ";                        
                        if (this.id == me.settings.defaultChart) { cssClass += "button-toggle-active "; }
                        $.each(this.notAllowedInterval, function () { cssClass += "not-allowed-interval-" + this + " "; });

                        var chart = ButtonMenu._setSimpleButton("btn-" + this.id, ["chart-type", this.id], cssClass, $("<i>", { class: this.icon }), this.name, false);                      
                        obj.append(chart);                       
                        chartCounter++;
                    }
                });

                //hide if we only have one single chart 
                if (chartCounter == 1) obj.hide();

                obj.find(".button-toggle").button();
            }


            if (me.settings.menu.top.opt.enabled) {
                obj = me.vcMenu.menu.top.opt;
                if (me.settings.menu.top.showHeaders) {
                    //obj.append($("<div>").addClass("vc-list-header-simple").html(me.specific.resources.more));

                    obj.append(ButtonMenu._setMenuHeader("", me.specific.resources.more));
                }

                //and some more icons
                //if (me.settings.menu.top.opt.showRules) obj.append($("<div>").attr("id", "btn-rules").addClass("button-toggle").html("<i class='fa fa-magic'></i><br/>" + me.specific.resources.calculation));
                //if (me.settings.menu.top.opt.showTags) obj.append($("<div>").attr("id", "btn-tags").addClass("button-toggle ").html("<i class='fa-regular fa-tags'></i><br/>" + me.specific.resources.tags));
                //if (me.settings.menu.top.opt.showInterventions) obj.append($("<div>").attr("id", "btn-intervention").addClass("button-toggle ").html("<i class='fa-regular fa-calendar'></i><br/>" + me.specific.resources.interventions));
                //if (me.settings.menu.top.opt.showTickets) obj.append($("<div>").attr("id", "btn-ticket").addClass("button-toggle ").html("<i class='fa-regular fa-ticket'></i><br/>" + me.specific.resources.tickets));

                if (me.settings.menu.top.opt.showRules) obj.append(ButtonMenu._setSimpleButton("btn-rules", "", "", $("<i>", { class: 'fa fa-magic' }), me.specific.resources.calculation, false, "", smallMenuButtons ? 70 : 0));
                if (me.settings.menu.top.opt.showTags) obj.append(ButtonMenu._setSimpleButton("btn-tags", "", "", $("<i>", { class: 'fa-regular fa-tags' }), me.specific.resources.tags, false, "", smallMenuButtons ? 70 : 0));
                if (me.settings.menu.top.opt.showInterventions) obj.append(ButtonMenu._setSimpleButton("btn-intervention", "", "", $("<i>", { class: 'fa-regular fa-calendar' }), me.specific.resources.interventions, false, "", smallMenuButtons ? 70 : 0));
                if (me.settings.menu.top.opt.showTickets) obj.append(ButtonMenu._setSimpleButton("btn-ticket", "", "", $("<i>", { class: 'fa-regular fa-ticket' }), me.specific.resources.tickets, false, "", smallMenuButtons ? 70 : 0));

                /*obj.find(".button-toggle").button();*/
            }

            // if archive and datacenter is activated, add datacenter heatmap button
            if ((me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart) && me.settings.defaultChart == "archive") {
                obj = me.vcMenu.menu.top.dcProject;
                if (me.settings.menu.top.showHeaders) obj.append(ButtonMenu._setMenuHeader("header-dc-project", "Datacenter"));
                obj.append(ButtonMenu._setSimpleButton("btn-dc-heatmap", "", "", $("<i>", { class: 'fa-regular fa-file-export' }), "Heatmap", false, "", smallMenuButtons ? 70 : 0));
                obj.find("#btn-dc-heatmap").addClass("no-margin-right"); 
            }

            if (me.settings.menu.top.export.enabled) {
                //first add the top menu button 
                obj = me.vcMenu.menu.top.exportBtn;
                if (me.settings.menu.top.showHeaders) obj.append(ButtonMenu._setMenuHeader("", me.specific.resources.export));   // obj.append($("<div>").addClass("vc-list-header-simple").html(me.specific.resources.export));
                //obj.append($("<div>").attr("id", "btn-export-menu").addClass("button-toggle").html("<i class='fa-regular fa-file-export'></i><br/>" + me.specific.resources.export));
                obj.append(ButtonMenu._setSimpleButton("btn-export-menu", "", "", $("<i>", { class: 'fa-regular fa-file-export' }), me.specific.resources.export, false, "", smallMenuButtons ? 70 : 0));
                /*obj.find(".button-toggle").button();*/

                //now add the export content menu
                settings = me.settings.menu.top.export;
                me.vcMenu.menu.top.export = {}
                let exp = me.vcMenu.menu.top.export;
                exp.wrapper = $("<div>").attr("id", "m-export");
                exp.menu = $("<div>").attr("id", "m-export-menu");
                exp.content = $("<div>").attr("id", "m-export-content").addClass("vc-grid-margin-top").width(me.settings.menu.top.export.width);
                exp.btn = $("<div>").attr("id", "btn-export").html(me.specific.resources.exportData).button();
                exp.wrapper.append($("<div>").addClass("vc-list-header-simple").html(me.specific.resources.export), exp.menu, exp.content, exp.btn);

                obj = me.vcMenu.menu.top.export.menu;
                obj.html("");
                obj.append($("<div>").data("type", "xls").html("<i class='fa fa-file-excel'></i><br/>" + "XLS"));
                obj.append($("<div>").data("type", "csv").html("<i class='fa fa-file-csv'></i><br/>" + "CSV"));
                obj.append($("<div>").data("type", "jpg").html("<i class='fa-regular fa-file-image'></i><br/>" + "JPG"));
                obj.append($("<div>").data("type", "png").html("<i class='fa fa-file-image'></i><br/>" + "PNG"));
                obj.append($("<div>").data("type", "pdf").html("<i class='fa fa-file-pdf'></i><br/>" + "PDF"));
                obj.find("div").addClass("file-export");
                if (settings.showFavorites) obj.append($("<div>").attr("id", "btn-favorites").data("type", "favorites").html("<i class='fa fa-display'></i><br/>" + me.specific.resources.favorites));
                if (settings.showShare) obj.append($("<div>").attr("id", "btn-share").data("type", "share").html("<i class='fa fa-share-all'></i><br/>" + me.specific.resources.share));

                obj.find("div").addClass("button-toggle").button();

            }

            // if full menu shall be shown, overview wrapper needs to be hidden
            if (!me.settings.menu.top.showMenuAsDropdown)
                me.vcMenu.menu.top.overview.wrapper.hide();
            else
                me._addTopMenuDropdownSubmenus(); // add the selection buttons and the dropdown list for ddl top menu

            //if we do not show any divs in the top menu except the export we have to remove the bottom margin
            if (me.fnd("#m-top > div:visible").not('#m-export-wrapper').length == 0) {
                me.vcMenu.menu.top.wrapper.removeClass("vc-grid-margin-bottom");
            }

            //add selection and reload button
            obj = me.vcMenu.menu.main.button;

            if (me.settings.menu.main.button.enabled) {

                if (!me.settings.menu.main.button.showTakeBtnOnly) {
                    //we only add the selection button if we want to toggle the selection part and the content
                    if (me.settings.toggleView) {
                        //obj.append($("<div>").attr("id", "btn-select").addClass("button-main vc-grid-margin-right active").html("<i class='fa fa-bars'></i><br/>" + me.specific.resources.selection))
                        obj.append(objDefaultButtons._setMainButton("btn-select", "<i class='fa fa-bars'></i><br/>", me.specific.resources.selection).addClass("active vc-grid-margin-right"));

                    };

                    //obj.append($("<div>").attr("id", "btn-reload").addClass("button-main active").html("<i id='btn-reload-icon' class='fa fa-check'></i><br/><span id='btn-reload-caption'>" + me.specific.resources.reload + "</span>"));
                    obj.append(objDefaultButtons._setMainButton("btn-reload", "<i id='btn-reload-icon' class='fa fa-check'></i><br/><span id='btn-reload-caption'>", me.specific.resources.reload).addClass("active"));

                } else {

                    let btn = $("<div>").attr("id", "btn-take").addClass("button-main active vc-grid-margin-bottom").html("<i class='fa fa-bars'></i><br/>" + me.specific.resources.take);
                    //btn.button();
                    obj.append(btn);
                }
            }


            //add date comparision
            if (me.settings.menu.main.dateComparison.enabled) {
                me.vcMenu.menu.main.specificIntervalCompare = $("<input>").attr("type", "number").attr("id", "txt-date-compare").addClass("txtEnabled").val(-1);
                me.vcMenu.menu.main.specificIntervalCompareCaption = $("<span>").html(me.specific.resources.day);


                me.vcMenu.menu.main.specificDateCompare = $("<div>").attr("id", "div-vcdate-compare");
                me.vcMenu.menu.main.specificDateCompare.vcDate({
                    mode: "Range", align: "center", interval: 1, langID: me.settings.userLangIDForCulture, callback: function (obj) {
                        me.status.date.dateRangeComparison = JSON.parse(JSON.stringify(obj.dateRange));

                        if (me.ready) { me._trigger("MenuChanged", true); }
                    }
                })

                me.vcMenu.menu.main.dateComparison.vcOptionBox({
                    caption: me.specific.resources.comparison, items: [
                        { button: me.specific.resources.date, clickable: true, content: $("<div>").html(me.vcMenu.menu.main.specificIntervalCompare).append(me.vcMenu.menu.main.specificIntervalCompareCaption) },
                        {
                            button: me.specific.resources.period, clickable: true, content: me.vcMenu.menu.main.specificDateCompare
                        },
                        { button: me.specific.resources.lastYear, clickable: true, content: $("<div>").html(me.specific.resources.lastYearComparison) }
                    ], callback: function () { }
                });

            }


            if (me.settings.menu.main.rampResolution.enabled) {
                obj = me.vcMenu.menu.main.rampResolution;
                //TODO: translate

                var resolutionBox = $("<div>").attr("id", "div-resolution-box").addClass("vc-grid-margin-right float");
                var resolutionContent = $("<div>");
                var resolutionContentSingle = $("<div>").addClass("res-single").html(me.specific.resources.dailyResolution);
                var resolutionContentRest = $("<div>").addClass("res-rest").html(me.specific.resources.dayTime);

                //me.specific.resolution.dailyResolution))

                var ddlResolution = $("<select>").attr("id", "ramp-option-archive-resolution").data("optid", 20).addClass("ddl vc-grid-margin-left vc-grid-margin-right");
                ddlResolution.append($("<option>").val("1").text("15 min"));
                ddlResolution.append($("<option>").val("2").text("30 min"));
                ddlResolution.append($("<option>").val("4").text("1 h"));
                ddlResolution.append($("<option>").val("8").text("2 h"));
                ddlResolution.append($("<option>").val("12").text("3 h"));
                ddlResolution.append($("<option>").val("16").text("4 h"));
                ddlResolution.append($("<option>").val("24").text("6 h"));
                ddlResolution.append($("<option>").val("32").text("8 h"));
                ddlResolution.append($("<option>").val("48").text("12 h"));
                resolutionContentSingle.append(ddlResolution);

                resolutionContentSingle.append($("<i>").attr("id", "ramp-option-unsmoothed").data("optid", 11).attr("title", me.specific.resources.unsmoothedValues).addClass("ramp-icon option button-toggle fa fa-water-lower"));
                resolutionContent.append(resolutionContentSingle);


                var ddlStartHour = $("<select>").attr("id", "ramp-option-start-hour").addClass("ddl vc-grid-margin-left");
                ddlStartHour.append($("<option>").val(0).text("0 - 24 h"));
                for (var i = 1; i < 24; i++) {
                    ddlStartHour.append($("<option>").val(i).text(i + " - " + i + " h"));
                }

                resolutionContentRest.append(ddlStartHour);
                resolutionContent.append(resolutionContentRest);
                resolutionBox.vcOptionBox({
                    caption: me.specific.resources.resolution, items: [
                        { button: me.specific.resources.dataResolution, clickable: false, content: resolutionContent },
                    ], callback: function () { }
                });
                obj.append(resolutionBox);

            }

            if (me.settings.menu.main.rampOptions.enabled) {
                obj = me.vcMenu.menu.main.rampOptions;

                obj.append($("<div>").data("type", "spline").attr("title", me.specific.resources.diagram + ": " + me.specific.resources.lines).addClass("chart-type button-toggle button-toggle-active ").html("<i class='fa fa-chart-line'></i><br/>" + me.specific.resources.lines));
                obj.append($("<div>").data("type", "column").attr("title", me.specific.resources.diagram + ": " + me.specific.resources.columns).addClass("chart-type button-toggle ").html("<i class='fa fa-chart-column'></i><br/>" + me.specific.resources.columns));
                obj.append($("<div>").data("type", "areaspline").attr("title", me.specific.resources.diagram + ": " + me.specific.resources.areaChart).addClass("chart-type button-toggle ").html("<i class='fa fa-chart-area'></i><br/>" + me.specific.resources.areaChart));
                obj.find(".chart-type").button();
                obj.append($("<br/>"));

                obj.append($("<i>").attr("id", "ramp-option-sep-temp").data("optid", 1).attr("title", me.specific.resources.showTemperatureSeparately).addClass("ramp-icon option button-toggle fa fa-temperature-list"));
                obj.append($("<i>").attr("id", "ramp-option-sep-axis").data("optid", 2).attr("title", me.specific.resources.separateSignalsAndMeta).addClass("ramp-icon option button-toggle fa fa-diagram-sankey"));
                obj.append($("<i>").attr("id", "ramp-option-show-interventions").data("optid", 0).attr("title", me.specific.resources.showInterventions).addClass("ramp-icon option button-toggle fa-regular fa-calendar"));


                obj.append($("<i>").attr("id", "ramp-option-fix-tooltip").data("optid", 4).attr("title", me.specific.resources.fixTooltip).addClass("ramp-icon option button-toggle fa fa-message-captions"));
                obj.append($("<i>").attr("id", "ramp-option-add-plotline").data("optid", 3).attr("title", me.specific.resources.showPlotLines).addClass("ramp-icon option button-toggle fa-regular fa-table-cells"));
                obj.append($("<i>").attr("id", "ramp-option-no-zoom").data("optid", 5).attr("title", me.specific.resources.deactivateZoom).addClass("ramp-icon option button-toggle fa fa-tablet"));

            }

            //EXPERIMENTAL .- prototype code here
            if (me.settings.menu.main.rampTempCharts.enabled) objChartTempHistory._handleExperimentalTempCharts(me);
            //add history
            if (me.settings.menu.main.history.enabled) objChartTempHistory._addHistoryButtons(me);

            //add choice list buttons and caption
            obj = me.vcMenu.selection.choice.caption;
            obj.html($("<div>").addClass("vc-list-header-simple ").html(me.resources.selection));
            if (me.settings.enableMeta) {
                obj.append($("<div>").data("choiceListId", 0).addClass("button-toggle button-toggle-active").html("<i class='fa fa-signal'></i><br/>" + me.specific.resources.measurementPoints + " (<span id='span-counter' class='span-choice-signal-counter-0'>0</span>)"));
                obj.append($("<div>").data("choiceListId", 1).addClass("button-toggle").html("<i class='fa fa-building'></i><br/>" + me.specific.resources.referenceSizes + " (<span id='span-counter' class='span-choice-signal-counter-1'>0</span>)"));
            }


            //add tree menu buttons
            obj = me.vcMenu.selection.treeMenu.button;
            obj.html($("<div>").addClass("vc-list-header-simple ").html(me.specific.resources.menu));
            obj.append($("<div>").data("menuid", 0).addClass("button-toggle button-toggle-active treemenu-btn").attr("title", me.specific.resources.tags).html("<i class='fa fa-tags'></i>"));
            obj.append($("<div>").data("menuid", 1).addClass("button-toggle treemenu-btn").attr("title", me.specific.resources.hardware).html("<i class='fa fa-memory'></i>"));
            if (me.settings.menu.top.opt.showTickets) obj.append($("<div>").data("menuid", 2).addClass("button-toggle treemenu-btn").attr("title", me.specific.resources.tickets).html("<i class='fa-regular fa-ticket'></i>"));
            obj.append($("<div>").data("menuid", 3).addClass("button-toggle treemenu-btn").attr("title", me.specific.resources.rules).html("<i class='fa fa-magic'></i>"));
            if (me.settings.userRights.isAdmin) obj.append($("<div>").data("menuid", 4).addClass("button-toggle treemenu-btn").attr("title", me.specific.resources.validation).html("<i class='fa-regular fa-list-check'></i>"));

            me.vcMenu.selection.entries.menu.caption.html($("<div>").addClass("vc-list-header-simple ").html(me.specific.resources.list));

            //add vc-filter
            obj = me.vcMenu.selection.entries.menu.filter;
            var firstLine = $("<div>").css("display", "flex");
            firstLine.append($("<div>").attr("id", "div-filter").addClass("vc-filter vc-grid-margin-top vc-grid-" + me.settings.selection.entries.filter.vcFilterCols + "col").css("width", "100%"));
            obj.append(firstLine);

            if (me.settings.signalSelection) {

                if (me.settings.selection.choice.enabled) {
                    obj.append($("<div>").attr("id", "btn-choice-clear").addClass("vc-grid-margin-top vc-grid-margin-right").html("<i class='fa fa-trash'></i> " + me.specific.resources.clearSelectionList));
                    obj.append($("<div>").attr("id", "btn-choice-add-all").addClass("vc-grid-margin-top vc-grid-margin-right").html("<i class='fa fa-angles-left'></i> " + me.specific.resources.addAll));
                    obj.append($("<div>").attr("id", "btn-choice-remove-all").addClass("vc-grid-margin-top").html("<i class='fa fa-angles-right'></i> " + me.specific.resources.removeAll));

                }
            }

            if (me.settings.menu.top.datatype.showDataCenter || me.specific.DataCenterStart) {
                me.vcMenu.selection.entries.menu.dcBtn.append($("<div>").attr("id", "btn-activate-dc").data("optid", 7).addClass("not-allowed-interval-5 vc-grid-margin-top vc-grid-margin-left button-main active").html("<i class='fa fa-medkit' style='margin-top:8px;'></i><br/>" + me.specific.resources.datacenter).css({ "width": "100px", "font-size": "11px" }));              
                objDataCenter._initDcFeatureSelection(me);
                objDataCenter._initDcFilterBox(me);

                // TODO MKU: check if filters shall be also available outside of the archive
                if (me.settings.defaultChart != "archive") {
                    me.fnd("#btn-activate-dc").hide();
                }
            }


            if (me.settings.selection.entries.signals.showIcons) {
                obj = me.vcMenu.selection.entries.signalDetails;

                // close button to close the icon chart
                var btnClose = $("<div>").attr("id", "btn-close-signal-details").addClass("button-toggle").html(me.specific.resources.close);
                btnClose.on("click", function () {
                    me._closeIconChart();
                }).button();
                obj.html(btnClose);
                obj.append("<hr/>");

                obj.append($("<div>").attr("id", "s-signal-details-content"));
            }

            me._fillSubvisualStructure();

            //we make the first menu status
            me._trigger("MenuChanged", true);

        } catch (e) { me._writeErr(e); }
    },

    _checkHeaderVisibility: function (settings, keySubstring) {
        /// <summary>
        /// function to check the visibility of menu items to toggle the menu header visibility correctly
        /// </summary>
        var me = this;
        try {

            var keys = Object.keys(settings)
                .filter((key) => key.includes(keySubstring))
                .reduce((obj, key) => {
                    return Object.assign(obj, {
                        [key]: me.settings.menu.top.datatype[key]
                    });
                }, {});

            var count = 0;
            $.each(keys, function (key, val) {
                if (val === true)
                    count++;
            });

            if (count > 0)
                return true;
            else
                return false;

        } catch (e) { me._writeErr(e); }
    },

    _addTopMenuDropdownSubmenus: function () {
        /// <summary>
        /// This function adds the html structure for the drop down menus for the selection of interval, charts and datatype
        /// </summary>
        var me = this;
        try {

            // copy export button and options to overview wrapper; otherwise they are not visible in the top menu
            me.vcMenu.menu.top.overview.exportBtn.html(me.vcMenu.menu.top.exportBtn);
            me.vcMenu.menu.top.overview.opt.html(me.vcMenu.menu.top.opt);
            me.vcMenu.menu.top.overview.dcProject.html(me.vcMenu.menu.top.dcProject);

            // if normal version, interval is copied to overview wrapper; otherwise it is not visible in the top menu
            if(!me.settings.mobile)
                me.vcMenu.menu.top.overview.interval.html(me.vcMenu.menu.top.interval);

            // dropdown menu for interval selection
            let obj = me.vcMenu.menu.top.interval;

            var wMainButtons = me.vcMenu.menu.main.button.outerWidth();
            var wBtn = (wMainButtons - 18 - 9) / 3;

            // interval as dropdown only for mobile version
            if (me.settings.mobile) {
                obj.append($("<div>").attr("id", "btn-select-interval").addClass("button-toggle").css({ "display": "table", "width": "92.33px", "box-sizing": "border-box", "height": "39px", "padding": "2.5px" }).html("<i class='fa fa-calendar-day'></i><br/>" + me.specific.resources.day).button());
                var currStr = obj.find("#btn-select-interval").html();
                obj.find("#btn-select-interval").html(currStr + "<div class='color-bg-secondary separation-line'></div>" + "<i class='ddl-select-btn fa fa-light fa-angles-down'></i>"); // add dropdown arrow icon
                obj.find("#btn-select-interval > span").css("margin-right", "20px");
                obj.menu = $("<div>").attr("id", "m-overview-interval-menu").addClass("ddl-menu").css("width", wBtn + 2);
                obj.find(".interval").addClass("margin-elements");
                obj.menu.append($("<div>").addClass("margin-elements menu-sep-line"));
                obj.menu.append(obj.find(".interval").css("width", wBtn)); // add interval buttons to interval dropdown menu
                obj.append(obj.menu);

                obj.menu.hide(); // hide the dropdown menu by default
                me.vcMenu.menu.top.overview.interval.html(me.vcMenu.menu.top.interval);
            }

            // dropdown menu for charts selection
            obj = me.vcMenu.menu.top.charts;

            obj.append($("<div>").attr("id", "btn-select-charts").addClass("button-toggle").css({ /*"display": "table", */"width": "97.33px", "box-sizing": "border-box", "height": "39px", "padding": "4px" }).button());
            obj.menu = $("<div>").attr("id", "m-overview-charts-menu").addClass("ddl-menu").css("width", wBtn + 7);
            obj.find(".chart-type").addClass("margin-elements");
            obj.menu.append($("<div>").addClass("margin-elements menu-sep-line")); //.css("height", "2px"));
            obj.menu.append(obj.find(".chart-type").css("width", wBtn + 5));
            obj.append(obj.menu);

            obj.menu.hide(); // hide the dropdown menu by default
            me.vcMenu.menu.top.overview.charts.html(me.vcMenu.menu.top.charts);

            //dropdown menu for datatype selection 
            obj = me.vcMenu.menu.top.dataType;

            obj.append($("<div>").attr("id", "btn-select-datatype").addClass("button-toggle").css({ /*"display": "table", */"width": "92.33px", "box-sizing": "border-box", "height": "39px", "padding": "3px" }).html("<i class='fa fa-solid fa-bars'></i><br/>" + me.specific.resources.selection).button());
            var currStr = obj.find("#btn-select-datatype").html(); 
            obj.find("#btn-select-datatype").html(currStr + "<div class='color-bg-secondary separation-line'></div>" + "<i class='ddl-select-btn fa fa-light fa-angles-down'></i>"); // add dropdown arrow icon
            obj.find("#btn-select-datatype > span").css("margin-right", "20px");
            obj.menu = $("<div>").attr("id", "m-overview-datatype-menu").addClass("ddl-menu").css("width", wBtn + 2); 
            obj.find(".datatype").addClass("margin-elements");
            obj.menu.append($("<div>").addClass("margin-elements menu-sep-line")); //.css("height", "2px"));
            obj.menu.append(obj.find(".datatype").css("width", wBtn));
            obj.append(obj.menu);

            obj.menu.hide(); // hide the dropdown menu by default
            me.vcMenu.menu.top.overview.dataType.html(me.vcMenu.menu.top.dataType);

        } catch (e) { me._writeErr(e); }
    },


    _closeIconChart: function () {
        /// <summary>
        /// function to close the icon chart
        /// </summary>
        var me = this;
        try {

            me.status.signalDetails.show = false;
            me.vcMenu.selection.entries.signals.show();
            me.vcMenu.selection.entries.menu.wrapper.show();
            me.vcMenu.selection.entries.signalDetails.hide();

            // reset currentIconChart object
            me.settings.currentIconChart.iconChart = null;
            me.settings.currentIconChart.active = false;

            //disable export button
            me.vcMenu.menu.top.exportBtn.find("#btn-export-menu").toggleClass("inactive", true);

        } catch (e) { me._writeErr(e); }
    },

    _buildStructure: function () {
        /// <summary>
        /// we build up the structure of the different parts
        /// </summary>
        var me = this;
        try {

            //first the menu
            me.vcMenu.menu = {};
            
            me.vcMenu.menu.wrapper = $("<div>").attr("id", "m-wrapper").addClass("wrap");

            //we start with the top menu
            me.vcMenu.menu.top = {};
            me.vcMenu.menu.top.overview = {};

            //we add the additional wrapper for the top menu with dropdown list
            let obj = me.vcMenu.menu.top.overview;
            obj.wrapper = $("<div>").attr("id", "m-top-overview").addClass("wrap");
            obj.list = $("<div>").attr("id", "m-top-overview-list").addClass("float vc-grid-margin-bottom");
            obj.exportBtn = $("<div>").attr("id", "m-overview-export-wrapper");
            obj.interval = $("<div>").attr("id", "m-overview-interval-wrapper");
            obj.dcProject = $("<div>").attr("id", "m-overview-dc-project-wrapper");
            obj.charts = $("<div>").attr("id", "m-overview-charts-wrapper");
            obj.dataType = $("<div>").attr("id", "m-overview-datatype-wrapper");
            obj.opt = $("<div>").attr("id", "m-overview-opt-wrapper");

            obj.wrapper.append(obj.dcProject, obj.interval, obj.charts, obj.dataType, obj.list, obj.opt, obj.exportBtn);

            obj = me.vcMenu.menu.top;
            obj.wrapper = $("<div>").attr("id", "m-top").addClass("wrap vc-grid-margin-bottom");
            obj.interval = ButtonMenu._setMenuGroup("m-interval", true); // $("<div>").attr("id", "m-interval").addClass("float vc-grid-margin-right");
            obj.dcProject = ButtonMenu._setMenuGroup("m-dc-project", false).css("margin-right", "17px");
            obj.dataType = ButtonMenu._setMenuGroup("m-datatype", true); // $("<div>").attr("id", "m-datatype").addClass("float vc-grid-margin-right");
            obj.charts = ButtonMenu._setMenuGroup("m-charts", true); // $("<div>").attr("id", "m-charts").addClass("float vc-grid-margin-right");
            obj.opt = ButtonMenu._setMenuGroup("m-opt", true); // $("<div>").attr("id", "m-opt").addClass("float  vc-grid-margin-right");
            obj.exportBtn = ButtonMenu._setMenuGroup("m-export-wrapper", false), // $("<div>").attr("id", "m-export-wrapper");
            obj.wrapper.append(obj.dcProject, obj.interval, obj.dataType, obj.charts, obj.opt, obj.exportBtn);


            //then the main menu
            me.vcMenu.menu.main = {};
            obj = me.vcMenu.menu.main;
            obj.wrapper = $("<div>").attr("id", "m-main").addClass("wrap vc-grid-margin-bottom");
            obj.button = $("<div>").attr("id", "m-button").addClass("float vc-grid-margin-right");

            obj.rightWrapper = $("<div>").attr("id", "m-rightWrapper").addClass("wrap float");

            obj.date = $("<div>").attr("id", "m-date").addClass("optionbox float vc-grid-margin-right vc-grid-margin-bottom");
            obj.dateComparison = $("<div>").attr("id", "m-date-comparison").addClass("optionbox float vc-grid-margin-right vc-grid-margin-bottom");
            obj.rampResolution = $("<div>").attr("id", "m-ramp-resolution").addClass("optionbox float  vc-grid-margin-right vc-grid-margin-bottom");
            obj.rampOptions = $("<div>").attr("id", "m-ramp-options").addClass("optionbox float vc-grid-margin-bottom");

            obj.specificOptions = $("<div>").attr("id", "m-specific-options").addClass("optionbox float vc-grid-margin-bottom");

            obj.rightWrapper.append(obj.date, obj.dateComparison, obj.rampResolution, obj.rampOptions, obj.specificOptions);

            obj.breakLine = $("<div>").css("clear", "both");
            obj.history = $("<div>").attr("id", "m-history");
            obj.rampTempCharts = $("<div>").attr("id", "m-ramp-temp-charts").addClass("optionbox vc-grid-margin-bottom");


            obj.wrapper.append(obj.button, obj.rightWrapper, obj.breakLine, obj.history, obj.rampTempCharts);

            //we add everygthing to the vcMenu
            me.vcMenu.menu.wrapper.append(me.vcMenu.menu.top.overview.wrapper, me.vcMenu.menu.top.wrapper, me.vcMenu.menu.main.wrapper);

            //now the selection 
            me.vcMenu.selection = {};
            me.vcMenu.selection.wrapper = $("<div>").attr("id", "s-wrapper").addClass("wrap");

            me.vcMenu.selection.choice = {};
            obj = me.vcMenu.selection.choice;
            obj.wrapper = $("<div>").attr("id", "s-choice").addClass("float wrap vc-list vc-grid-margin-right");
            obj.caption = $("<div>").attr("id", "s-choice-caption").addClass("float captions fix vc-grid-margin-bottom");
            obj.list = $("<div>").attr("id", "s-choice-list").addClass("float fix   vc-list-table");
            obj.wrapper.append(obj.caption, obj.list);
            
            //first the left tree menu
            me.vcMenu.selection.treeMenu = {};
            obj = me.vcMenu.selection.treeMenu;

            obj.wrapper = $("<div>").attr("id", "s-treemenu").addClass("float wrap  vc-grid-margin-right");
            obj.button = $("<div>").attr("id", "s-treemenu-btn").addClass("float captions fix");
            obj.list = $("<div>").attr("id", "s-treemenu-list").addClass("float vc-grid-margin-top fix");
            obj.wrapper.append(obj.button, obj.list);

            //now the entry part on the right
            me.vcMenu.selection.entries = {};
            obj = me.vcMenu.selection.entries;
            obj.wrapper = $("<div>").attr("id", "s-entries").addClass("float vc-list wrap");
            obj.menu = {};
            obj.menu.wrapper = $("<div>").attr("id", "s-menu").addClass("wrap  vc-grid-margin-bottom");
            obj.menu.caption = $("<div>").attr("id", "s-entries-caption"); 
            obj.menu.filter = $("<div>").attr("id", "s-filter").addClass("float");
            obj.menu.dcBtn = $("<div>").attr("id", "s-btn-dc").addClass("float vc-grid-margin-right");
            obj.menu.dcFeatures = $("<div>").attr("id", "s-dc-features").addClass("float vc-grid-margin-right vc-grid-margin-top");
            obj.menu.dcFilterBox = $("<div>").attr("id", "s-dc-filter-box").addClass("float not-allowed-interval-5 vc-grid-margin-top").css("height", "77px").css("width", "430px"); // TODO MKU: bessere lösung!!
            obj.menu.dcFilter = $("<div>").attr("id", "ds-s-filter").addClass("float vc-grid-margin-right").css("height", "90px");    
            obj.menu.button = $("<div>").attr("id", "s-button").addClass("float");
            obj.menu.wrapper.append(obj.menu.caption, obj.menu.filter, obj.menu.button, obj.menu.dcBtn, obj.menu.dcFeatures, obj.menu.dcFilterBox, obj.menu.dcFilter);

            obj.signals = $("<div>").attr("id", "s-signals").addClass("float vc-list vc-list-table");
            obj.signalDetails = $("<div>").attr("id", "s-signal-details");
            obj.info = $("<div>").attr("id", "entry-info").addClass("note").hide();
            obj.wrapper.append(obj.menu.wrapper, obj.info, obj.signals, obj.signalDetails);

            me.vcMenu.selection.wrapper.append(me.vcMenu.selection.choice.wrapper, me.vcMenu.selection.treeMenu.wrapper, me.vcMenu.selection.entries.wrapper);

            //add content
            me.vcMenu.content = $("<div>").attr("id", "my-content").addClass("is-hidden").html(me.vcC.getLoadingIcon());
            me.vcMenu.loading = $("<div>").attr("id", "archive-loading").addClass("archive-loading").html(me.vcC.getLoadingIcon()).hide();

            me.vcMenu.obj.append(me.vcMenu.loading, me.vcMenu.menu.wrapper, me.vcMenu.selection.wrapper, me.vcMenu.content);

            //we add the box css to very div
            me.fnd("div").addClass("box");


            return me.vcMenu.menu.mWrapper;
        } catch (e) { me._writeErr(e); }
        return null;
    },

    _setWidths: function () {
        /// <summary>
        ///  calculates and sets the widths of different items (headers of menu etc)
        /// </summary>
        let me = this;
        try {
            let wFull = parseInt(me.visual.outerWidth(true));
            let wMenu = 0;
            if (me.settings.selection.choice.enabled) {
                wMenu += me.vcMenu.selection.choice.wrapper.outerWidth(true);
            }

            // calculate width of tree menu buttons
            if (me.settings.selection.treemenu.enabled) {
                wMenu += me.vcMenu.selection.treeMenu.wrapper.outerWidth(true);     
                var wtreeBtns = ((me.vcMenu.selection.treeMenu.button.outerWidth() -1) / me.vcMenu.selection.treeMenu.button.find(".button-toggle").length);
                var treeMenuBtns = me.vcMenu.selection.treeMenu.button.find(".button-toggle").outerWidth(wtreeBtns);
            }


            me.status.widthEntries = parseInt(wFull - wMenu - 3);
            me.vcMenu.selection.entries.wrapper.width(me.status.widthEntries);

            if (wFull <= me.minWidthforTopMenu) {
                me.vcMenu.menu.top.wrapper.find("#m-datatype, #m-charts,  #m-opt").toggleClass("max-width", true);
            }
            me.vcMenu.content.width(wFull);


            if (me.settings.menu.top.interval.enabled) { 
                
                // if ddl top menu is active, set header widths of selection buttons in top overview list to correct values
                if (me.settings.menu.top.showMenuAsDropdown) {

                    var wWrapper = me.vcMenu.menu.wrapper.find("#m-charts").outerWidth();
                    me.vcMenu.menu.wrapper.find("#m-interval").width(wWrapper);

                    // header width
                    me.vcMenu.menu.wrapper.find("#m-datatype .vc-list-header-simple").css({ "width": "92.33px", "box-sizing": "border-box" });
                    me.vcMenu.menu.wrapper.find("#m-charts .vc-list-header-simple").css({ "width": "97.33px", "box-sizing": "border-box" }); 

                    // we set the interval wrapper to the small size for mobile version
                    if (me.settings.mobile)
                        me.vcMenu.menu.wrapper.find("#m-interval .vc-list-header-simple").css({ "width": "92.33px", "box-sizing": "border-box" });

                }

                // if normal version - not mobile - interval wrapper width is calculated depending on available interval buttons
                if (!me.settings.mobile) {
                    //let btn = me.vcMenu.menu.wrapper.find("#m-interval .button-toggle").css({ "width": "78px", "box-sizing": "border-box" }); // set width of interval buttons to exact value
                    //let margin = 1 * (btn.length - 1);
                    //let w = (btn.outerWidth() * btn.length) + margin;

                    //me.vcMenu.menu.wrapper.find("#m-interval .vc-list-header-simple").css({ "width": w, "box-sizing": "border-box" }); // set width of header to exact value


                    ButtonMenu._setHeaderWidth(me, "m-interval");
                }
            }

        } catch (e) { me._writeErr(e); }
    },


    _setMainMenuWidths: function () {
        //we set the width for the right wrapper in the main area
        //we also decide how many option boxes will fit in and set the width that always fit at least 2 option boxes
        //
        let me = this;
        try {

            let wFull = parseInt(me.visual.outerWidth(true));
            let obj = me.vcMenu.menu.main;
             //get the width of the right wrapper
            let rightWrapperWidth = wFull - obj.button.outerWidth(true) - 1;
            //get the number of optionboxes in the right wrapper
            let options = me.vcMenu.menu.main.rightWrapper.find(".optionbox:visible").length;

            
            //if the width of the optionboxes is larger than the wrapper width
            //... we set a min wrapper width - so we will always get at least 2 optionboxes per line
            if (options * me.optionBoxWidth > rightWrapperWidth) {
                rightWrapperWidth = me.minWidthforMainRightWrapper;
            }

            obj.rightWrapper.width(rightWrapperWidth);

        } catch (e) { me._writeErr(e); }
    },

    _setHeights: function () {
        let me = this;
        try {

            //hide menu if nothing is shown at all
            //if (me.vcMenu.menu.wrapper.height() <= 2) { me.vcMenu.menu.wrapper.addClass("is-hidden"); }

            let hFull = parseInt(me.options.invoke.container.height);
            let hMenu = me.vcMenu.menu.wrapper.outerHeight(true);
            let h = parseInt(hFull - hMenu - 10);

            me.status.heightContent = h;

            //set content and selection height
            me.vcMenu.content.height(h);
            me.vcMenu.selection.wrapper.height(h);
            me.vcMenu.selection.choice.wrapper.height(h - 4);
            me.vcMenu.selection.treeMenu.wrapper.height(h - 4);
            me.vcMenu.selection.entries.wrapper.height(h - 2);
            me.vcMenu.selection.entries.wrapper.css("min-height", me.vcMenu.selection.entries.wrapper.height());


            if (me.settings.selection.entries.signals.showIcons) {
                me.vcMenu.selection.entries.signalDetails.height(h);
                var hSignalDetailContent = parseInt(h - me.vcMenu.selection.entries.signalDetails.find("#btn-close-signal-details").height() - 45);
                me.vcMenu.selection.entries.signalDetails.find("#s-signal-details-content").height(hSignalDetailContent);
            }

            //set choice list
            if (me.settings.selection.choice.enabled) {
                me.vcMenu.selection.choice.list.height(parseInt(me.status.heightContent - me.vcMenu.selection.choice.caption.outerHeight(true) - 3));
            }

            // calculate height of tree menu buttons
            if (me.settings.selection.treemenu.enabled) {
                let btns = me.vcMenu.selection.choice.caption.find(".button-toggle");

                // if caption buttons are not visible, tree menu btns height is set to a specific value
                if (me.settings.defaultChart != "archive" && btns.length < 1) {
                    var treeMenuBtns = me.vcMenu.selection.treeMenu.button.find(".button-toggle").outerHeight(40);
                }
                else { // otherwise tree menu btn height is aligned with caption btn height
                    var bH = btns.outerHeight();
                    var treeMenuBtns = me.vcMenu.selection.treeMenu.button.find(".button-toggle").outerHeight(bH);
                }
            }

            //set tree menu list
            me.vcMenu.selection.treeMenu.list.height(parseInt(h - me.vcMenu.selection.wrapper.find("#s-treemenu-btn").outerHeight(true) - 14));
            me.vcMenu.selection.treeMenu.list.find(".vc-tree-menu-main").height(me.vcMenu.selection.treeMenu.list.height());

            if ($('.vctree-menu-3').length > 0)
                me.vcMenu.selection.treeMenu.list.vcTreeMenu3("setHeight", me.vcMenu.selection.treeMenu.list.height());

            //set signal heights
            let hEntriesMenu = me.vcMenu.selection.entries.menu.wrapper.outerHeight(true);

            h = parseInt(h - hEntriesMenu - 2);
            me.vcMenu.selection.entries.signals.height(h);


            var filter = me.vcMenu.selection.entries.menu.filter.find("#div-filter"); 
            if(me.vcMenu.selection.entries.menu.filter.find("#div-filter").vcFilter());                
                filter.vcFilter("setWidth", filter.width());




        } catch (e) { me._writeErr(e); }
    },


    //#endregion


    _getDebugStatus: function () {
        
        var s = JSON.stringify(this.status);
        s = s.replaceAll("{", "");
        s = s.replaceAll("}", "");
        s = s.replaceAll(",", "<br/>");
        return s;
    },

    callFunct: function (bEnd) {

        if (this.eventNamespace === ".MasterSignalList2") {
            let x = jQuery.now() + "   " + this.callFunct.caller.name;
            if (bEnd) x += "       on end";
            _VCMQ.produce(this.visual, this.vcgid, 'LOG', x);
        }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) { me.fnd("#m-wrapper, #s-wrapper").hide(); }
            return true;
        } catch (e) {
            me._writeErr( e); return false;
        }
    },


    destroy: function () {
        // destroy function is currently only called for multiple archives; for normal archive, a total reload is done

        try {

            sessionStorage.removeItem('allSignals');

            // ------------- remove all eventListeners --------------

            var eventNamespace = ".RampArchive" + this.uuid;
            $('body').off(eventNamespace); // remove all body event listeners
            $('body').off("click" + eventNamespace); // remove all click event listeners on body
            $(document).off("click" + eventNamespace); // remove all click event listeners on document
            $(this).off(eventNamespace);

            var eventNamespace2 = "." + this.container.id;
            $('body').off(eventNamespace2); // remove all body event listeners
            $('body').off("click" + eventNamespace2); // remove all click event listeners on body
            $(document).off(eventNamespace2); // remove all click event listeners on document
            $(this).off(eventNamespace2);

            //------- remove ui dialogs, otherwise they are not removed correctly ---------
            $(this.exportPopup).remove();
            $(this.chartClick.content).remove();
            $(this.chartClick.popup).remove();
            $(this.myDiv).remove();       


            // iterate all properties of this and remove everything and set it to null
            for (var key in this) {
                if (this.hasOwnProperty(key)) {    
                    if (key != 'element' && key != 'bindings' && key != 'container') {
                        if (this[key] && this[key].jquery) {
                            $(this[key]).removeData().remove(); // remove jQuery data and DOM element
                            this[key] = null; // set reference to null
                        } else {
                            this[key] = null; // not-jquery property are also set to null
                        }
                    }

                }
            }                       


            // remove all bindings and general element itself
            this.bindings = null;
            this.container = null;
            this.element = null; 

            $(this.bindings).remove(); 
            $(this.container).remove(); 
            $(this.element).remove(); 
                

        } catch (e) {
            me._writeErr(e); return false;
        }
    },

   
   

    //#region "subvisuals"

    _initSubvisualContent: function (status) {
        /// <summary>
        /// This function generates a default structure with a choice list on the left side and a content on the right
        /// It also inits the click handler for the choice list
        /// </summary>
        var me = this;
        try {

            if (!me.error) {

                status.subvisual.wrapper.width = me.vcMenu.content.width();
                status.subvisual.wrapper.height = status.heightContent - 2;
                status.subvisual.content.height = status.subvisual.wrapper.height;

                //build the default structure
                me.vcMenu.subvisual = {};
                me.vcMenu.subvisual.wrapper = $("<div>").attr("id", "m-subvisual-wrapper").addClass("wrap").width(me.status.subvisual.wrapper.width).height(me.status.subvisual.wrapper.height);

                me.vcMenu.content.html("");
                if (me.settings.subvisual.content.signalSelection) {
                    //we clone the current selection.choice object ;-) - so we get a new choice list
                    me.vcMenu.subvisual.choice = $("<div>").html(me.vcMenu.selection.choice.wrapper.clone());
                    me.vcMenu.subvisual.choice.find(".button-toggle, i").hide();
                    me.vcMenu.subvisual.choice.find("#s-choice-list").height(me.vcMenu.selection.choice.list.height() - 27);
                    me.vcMenu.subvisual.wrapper.append(me.vcMenu.subvisual.choice);
                    //calculate the new width for the sub content
                    status.subvisual.content.width = status.subvisual.wrapper.width - me.vcMenu.selection.choice.wrapper.outerWidth(true);
                    me.vcMenu.subvisual.content = $("<div>").attr("id", "s-subvisual-content").addClass("float wrap").height(status.subvisual.wrapper.height).width(status.subvisual.content.width).html(me.getLoadingIcon());
                    me.vcMenu.subvisual.wrapper.append(me.vcMenu.subvisual.content);
                    me.vcMenu.content.append(me.vcMenu.subvisual.wrapper);

                    me._initSubvisualChoiceClickHandler(status);

                    //if we do not find the selected bsaid in the list we take the first item in the list
                    if (me.status.signals.selectedBsaids.indexOf(status.subvisual.selectedBsaid) == -1) {
                        status.subvisual.selectedBsaid = me.status.signals.selectedBsaids[0];
                    }
                    //we mark the current item as selected
                    let lst = me.vcMenu.content.find("#m-subvisual-wrapper #s-choice-list .vc-list-item");
                    $(lst[me.status.signals.selectedBsaids.indexOf(status.subvisual.selectedBsaid)]).addClass("selected");


                    me._loadSubvisualFromChoiceList(status);

                } else {
                    //if we need no signal selection we set the content to the wrapper
                    me.vcMenu.subvisual.content = me.vcMenu.subvisual.wrapper;
                    me.vcMenu.content.append(me.vcMenu.subvisual.content);
                }
            }

        } catch (e) { me._writeErr(e); }
    },

    _initSubvisualChoiceClickHandler: function (status) {
        ///this function inits the click handler for the choice list of the sub visual
        var me = this;
        try {

            if (!me.error) {

                me.vcMenu.content.find("#m-subvisual-wrapper #s-choice-list").off("click", ".vc-list-item").on("click", ".vc-list-item", function () {
                    let obj = $(this);
                    if (!obj.hasClass("selected")) {

                        me.vcMenu.content.find("#m-subvisual-wrapper #s-choice-list .vc-list-item").removeClass("selected");
                        obj.addClass("selected");
                        status.subvisual.selectedBsaid = me.status.signals.selectedBsaids[obj.index()];
                        me._loadSubvisualFromChoiceList(status);
                    }
                });
            }
        } catch (e) { me._writeErr(e); }
    },

    _fillSubvisualStructure: function () {
        /// overwrite function in subvisual
    },

    _initSubvisualEvents: function () {
        /// overwrite function in subvisual
    },

    _loadSubvisualContent: function (contentStatus) {
        /// overwrite function in subvisual
    },

    _loadSubvisualFromChoiceList: function (status) {
       /// overwrite function in subvisual
    },

    //#endregion

});


